'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var antd = require('antd');

var classNames = _interopDefault(require('classnames'));

var React = require('react');

var React__default = _interopDefault(React);

var Input = _interopDefault(require('antd/lib/input'));

var Chart = _interopDefault(require('chart.js'));

var AntBreadcrumb = _interopDefault(require('antd/lib/breadcrumb'));

var Icon = _interopDefault(require('antd/lib/icon'));

var AntButton = _interopDefault(require('antd/lib/button'));

var popcorn = require('@popmotion/popcorn');

var framerMotion = require('framer-motion');

var reactLazyLoadImageComponent = require('react-lazy-load-image-component');

var AntDatePicker = _interopDefault(require('antd/lib/date-picker'));

var locale = _interopDefault(require('antd/lib/date-picker/locale/fr_FR'));

var AntdTabs = _interopDefault(require('antd/lib/tabs'));

var Dropdown = _interopDefault(require('antd/lib/dropdown'));

var AntSelect = _interopDefault(require('antd/lib/select'));

var AntInputNumber = _interopDefault(require('antd/lib/input-number'));

var AntModal = _interopDefault(require('antd/lib/modal'));

var AntdPopConfirm = _interopDefault(require('antd/lib/popconfirm'));

var AntSteps = _interopDefault(require('antd/lib/steps'));

var AntSwitch = _interopDefault(require('antd/lib/switch'));

var AntTable = _interopDefault(require('antd/lib/table'));

var AntTag = _interopDefault(require('antd/lib/tag'));

var AntTextArea = _interopDefault(require('antd/lib/input/TextArea'));

var ContentLoader = _interopDefault(require('react-content-loader'));

var material = require('@mui/material');

var ScrollLock = _interopDefault(require('react-scrolllock'));

var Flag = _interopDefault(require('react-world-flags'));

var Slider = _interopDefault(require('antd/lib/slider'));

var Radio = _interopDefault(require('antd/lib/radio'));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var styles = {
  "container": "AutoComplete-module_container__2Ufnl",
  "error": "AutoComplete-module_error__3Xssk",
  "ant-input-disabled": "AutoComplete-module_ant-input-disabled__rSEEy",
  "message": "AutoComplete-module_message__4cpm0",
  "icon": "AutoComplete-module_icon__Yh1qK",
  "selectOption": "AutoComplete-module_selectOption__2C7CV",
  "cta": "AutoComplete-module_cta__3rR_i"
};
var Option = antd.AutoComplete.Option;

var AutoComplete = function AutoComplete(_a) {
  var fields = _a.fields,
      CTA = _a.CTA,
      onChange = _a.onChange,
      onSelect = _a.onSelect,
      onSearch = _a.onSearch,
      _filterOption = _a.filterOption,
      children = _a.children,
      className = _a.className,
      restProps = __rest(_a, ["fields", "CTA", "onChange", "onSelect", "onSearch", "filterOption", "children", "className"]);

  if (CTA) {
    fields.unshift(_assign({}, CTA, {
      key: 'cta'
    }));
  }

  var handleChange = function handleChange(value) {
    if (onChange) {
      onChange(value);
    }
  };

  var handleSelect = function handleSelect(value, option) {
    if (value === 'cta' && CTA) {
      CTA.onClick();
    } else if (onSelect) {
      onSelect(value, option);
    }
  };

  var handleSearch = function handleSearch(value) {
    if (onSearch) {
      onSearch(value);
    }
  };

  return React__default.createElement(antd.AutoComplete, _assign({
    className: classNames(className, styles.container),
    onChange: handleChange,
    onSelect: handleSelect,
    onSearch: handleSearch
  }, restProps, {
    filterOption: function filterOption(inputValue, option) {
      // If we have an input we hide the CTA
      if (inputValue && CTA && option.props.children === CTA.label) return true;

      if (typeof _filterOption === 'function') {
        return _filterOption(inputValue, option);
      } else if (_filterOption) {
        return true;
      } else return true;
    }
  }), fields.map(function (field, i) {
    return React__default.createElement(Option, {
      className: styles.selectOption + " " + (CTA && i === 0 ? styles.cta : ''),
      key: field.key
    }, field.label);
  }));
};

var styles$1 = {
  "container": "InputField-module_container__-2Tpp",
  "error": "InputField-module_error__IsjFQ",
  "ant-input-disabled": "InputField-module_ant-input-disabled__1bB-h",
  "message": "InputField-module_message__2lBIk",
  "icon": "InputField-module_icon__12P65"
};

var InputField =
/** @class */
function (_super) {
  __extends(InputField, _super);

  function InputField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputField.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.error,
        error = _b === void 0 ? '' : _b,
        children = _a.children,
        restProps = __rest(_a, ["className", "error", "children"]);

    return React__default.createElement("div", {
      className: styles$1.container + " " + (error ? styles$1.error : '')
    }, !children && React__default.createElement(Input, _assign({
      className: styles$1.input + " " + className
    }, restProps)), children, error ? React__default.createElement("div", {
      className: styles$1.message
    }, error) : '');
  };

  return InputField;
}(React.Component);

var styles$2 = {
  "searching": "AutoCompleteField-module_searching__2io2c"
};

var AutoCompleteField = function AutoCompleteField(_a) {
  var _b;

  var defaultValue = _a.defaultValue,
      defaultLabel = _a.defaultLabel,
      _onSearch = _a.onSearch,
      onChangeValue = _a.onChangeValue,
      onSetInvalid = _a.onSetInvalid,
      fields = _a.fields,
      disabled = _a.disabled,
      placeholder = _a.placeholder,
      restProps = __rest(_a, ["defaultValue", "defaultLabel", "onSearch", "onChangeValue", "onSetInvalid", "fields", "disabled", "placeholder"]);

  var _c = React.useState(''),
      searchPattern = _c[0],
      setSearchPattern = _c[1];

  return React__default.createElement(InputField, _assign({}, restProps), React__default.createElement(AutoComplete, {
    fields: fields,
    className: classNames((_b = {}, _b[styles$2.searching] = searchPattern, _b)),
    defaultValue: defaultLabel,
    disabled: disabled,
    onSelect: function onSelect(v) {
      if (onChangeValue) onChangeValue(v.toString());
      setSearchPattern('');
    },
    onSearch: function onSearch(v) {
      setSearchPattern(v.toString());
      if (!v.toString() && onChangeValue) onChangeValue('');
      if (_onSearch) _onSearch(v);
    },
    onBlur: function onBlur() {
      if (searchPattern && onSetInvalid) onSetInvalid(true);
    },
    onFocus: function onFocus() {
      if (onSetInvalid) onSetInvalid(false);
    },
    placeholder: placeholder
  }));
};

var styles$3 = {
  "container": "BarChart-module_container__NoQJF",
  "graph": "BarChart-module_graph__3y_TR",
  "legend": "BarChart-module_legend__1aROP",
  "legendItem": "BarChart-module_legendItem__gOpI-",
  "legendRectangle": "BarChart-module_legendRectangle__2xYwm",
  "legendLabel": "BarChart-module_legendLabel__LnzpP"
};
var BarChart = React__default.memo(function (_a) {
  var datas = _a.datas,
      xLabels = _a.xLabels,
      containerClassName = _a.containerClassName;
  var canvasRef = React.useRef(null);
  var chart;
  React__default.useEffect(function () {
    var ctx = canvasRef.current && canvasRef.current.getContext('2d');
    if (!ctx) return;
    chart = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: datas.map(function (data) {
          return {
            label: data.label,
            data: data.values,
            backgroundColor: data.color
          };
        }),
        labels: xLabels
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            categoryPercentage: 1.0,
            barPercentage: 0.5
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
    return function () {
      chart.destroy();
    };
  }, [datas, xLabels]);
  return React__default.createElement("div", {
    className: styles$3.container + " " + containerClassName
  }, React__default.createElement("canvas", {
    className: styles$3.graph,
    ref: canvasRef
  }), React__default.createElement("div", {
    className: styles$3.legend
  }, datas.map(function (data) {
    return React__default.createElement("div", {
      className: styles$3.legendItem,
      key: data.label
    }, React__default.createElement("div", {
      className: styles$3.legendRectangle,
      style: {
        backgroundColor: data.color
      }
    }), React__default.createElement("span", {
      className: styles$3.legendLabel
    }, data.label));
  })));
});

var ellipseString = function ellipseString(str, length) {
  return str.length > length ? str.substring(0, length) + "..." : str;
};

var styles$4 = {
  "container": "Breadcrumb-module_container__3NCJO",
  "breadcrumbItem": "Breadcrumb-module_breadcrumbItem__1ThKI",
  "last": "Breadcrumb-module_last__2AiVB"
};

function itemRender(route, params, routes) {
  var last = routes.indexOf(route) === routes.length - 1;
  return last ? React__default.createElement("span", {
    className: styles$4.breadcrumbItem + " " + styles$4.last
  }, ellipseString(route.breadcrumbName, 12)) : React__default.createElement("a", {
    href: route.path
  }, React__default.createElement("span", {
    className: styles$4.breadcrumbItem
  }, ellipseString(route.breadcrumbName, 12)));
}

var Breadcrumb = function Breadcrumb(_a) {
  var className = _a.className,
      restProps = __rest(_a, ["className"]);

  return React__default.createElement(AntBreadcrumb, _assign({
    className: styles$4.container,
    separator: React__default.createElement(Icon, {
      type: "right",
      style: {
        fontSize: '10px'
      }
    }),
    itemRender: itemRender
  }, restProps));
};

(function (Theme) {
  Theme["DEFAULT"] = "default";
  Theme["PRIMARY"] = "primary";
  Theme["BLACK"] = "black";
  Theme["GHOST"] = "ghost";
  Theme["WHITEGHOST"] = "whiteGhost";
  Theme["WHITE"] = "white";
})(exports.Theme || (exports.Theme = {}));

(function (Size) {
  Size["SMALL"] = "small";
  Size["MEDIUM"] = "default";
  Size["LARGE"] = "large";
})(exports.Size || (exports.Size = {}));

(function (TagType) {
  TagType["ACTIVE"] = "active";
  TagType["INACTIVE"] = "inactive";
  TagType["DANGER"] = "danger";
})(exports.TagType || (exports.TagType = {}));

(function (CategoryColor) {
  CategoryColor["YELLOW"] = "#F2B230";
  CategoryColor["CYAN"] = "#70BAC2";
  CategoryColor["BLUE"] = "#3C82FF";
  CategoryColor["DARK_BLUE"] = "#30535A";
  CategoryColor["PRIMARY"] = "#151515";
  CategoryColor["LIGHT_GREY"] = "#D3DFE0";
})(exports.CategoryColor || (exports.CategoryColor = {}));

(function (Integration) {
  Integration["LIGHT"] = "light";
  Integration["GREEN"] = "green";
  Integration["DARK"] = "dark";
})(exports.Integration || (exports.Integration = {}));

(function (FilterType) {
  FilterType[FilterType["PRICE"] = 0] = "PRICE";
  FilterType[FilterType["OBJECT"] = 1] = "OBJECT";
  FilterType[FilterType["BRAND"] = 2] = "BRAND";
  FilterType[FilterType["STYLE"] = 3] = "STYLE";
  FilterType[FilterType["MATERIAL"] = 4] = "MATERIAL";
  FilterType[FilterType["ROOM"] = 5] = "ROOM";
  FilterType[FilterType["COLOR"] = 6] = "COLOR";
  FilterType[FilterType["ORIGIN"] = 7] = "ORIGIN";
  FilterType[FilterType["EMPTY"] = 8] = "EMPTY";
  FilterType[FilterType["HAVE3D"] = 9] = "HAVE3D";
  FilterType[FilterType["PROMOTED"] = 10] = "PROMOTED";
  FilterType[FilterType["ONLY_VISIBLE"] = 11] = "ONLY_VISIBLE";
  FilterType[FilterType["ENABLED"] = 12] = "ENABLED";
  FilterType[FilterType["HAVE_THUMBNAIL"] = 13] = "HAVE_THUMBNAIL";
  FilterType[FilterType["DIMENSIONS"] = 14] = "DIMENSIONS";
  FilterType[FilterType["PRODUCT_ID"] = 15] = "PRODUCT_ID";
  FilterType[FilterType["OBJECT_PARENT"] = 16] = "OBJECT_PARENT";
})(exports.FilterType || (exports.FilterType = {}));

var styles$5 = {
  "container": "Button-module_container__3PIsE",
  "default": "Button-module_default__2K-C8",
  "primary": "Button-module_primary__pg7GC",
  "black": "Button-module_black__1xeB8",
  "ghost": "Button-module_ghost__3v85p",
  "whiteGhost": "Button-module_whiteGhost__ixPxV",
  "white": "Button-module_white__1pOL3",
  "uppercase": "Button-module_uppercase__3NCY_"
};

var Button = function Button(_a) {
  var _b;

  var _c = _a.theme,
      theme = _c === void 0 ? exports.Theme.DEFAULT : _c,
      uppercase = _a.uppercase,
      className = _a.className,
      children = _a.children,
      restProps = __rest(_a, ["theme", "uppercase", "className", "children"]);

  return React.createElement(AntButton, _assign({
    className: classNames(styles$5.container, styles$5[theme], className, (_b = {}, _b[styles$5.uppercase] = uppercase, _b))
  }, restProps, {
    type: "primary"
  }), children);
};

var styles$6 = {
  "container": "Card-module_container__30DZM",
  "card": "Card-module_card__2R8Y7",
  "shadow": "Card-module_shadow__33UCB",
  "imageContainer": "Card-module_imageContainer__C9f9n",
  "image": "Card-module_image__1FKdX",
  "coverContainer": "Card-module_coverContainer__2Lzvg",
  "coverContainerSelected": "Card-module_coverContainerSelected__1Q_k0",
  "icons": "Card-module_icons__kxEE6",
  "checkbox": "Card-module_checkbox__43G5B",
  "fit": "Card-module_fit__3yLqZ",
  "placeHolder": "Card-module_placeHolder__HlgRg",
  "checkboxSelected": "Card-module_checkboxSelected__1Cpw5",
  "checkMark": "Card-module_checkMark__wKmKD",
  "collectionMenu": "Card-module_collectionMenu__2__a0",
  "hoverText": "Card-module_hoverText__1MpLi",
  "info": "Card-module_info__3kK1-",
  "presentation": "Card-module_presentation__2pBC_",
  "title": "Card-module_title__3M6Xc",
  "white": "Card-module_white__22SbE",
  "desc": "Card-module_desc__24054",
  "second": "Card-module_second__tWJDb",
  "footer": "Card-module_footer__3zUZ7",
  "side": "Card-module_side__1CVNJ",
  "sr": "Card-module_sr__3bV3H"
};

var Card = function Card(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k;

  var _l = _a.theme,
      theme = _l === void 0 ? exports.Theme.DEFAULT : _l,
      title = _a.title,
      desc = _a.desc,
      footer = _a.footer,
      secondName = _a.secondName,
      slug = _a.slug,
      image = _a.image,
      imgFit = _a.imgFit,
      _m = _a.imgBgColor,
      imgBgColor = _m === void 0 ? '#FFF' : _m,
      shadow = _a.shadow,
      selectable = _a.selectable,
      selected = _a.selected,
      onSelect = _a.onSelect,
      inner = _a.inner,
      ratio = _a.ratio,
      className = _a.className,
      hoverText = _a.hoverText,
      side = _a.side,
      topIcons = _a.topIcons,
      id = _a.id,
      enrichTopIcons = _a.enrichTopIcons,
      collectionMenu = _a.collectionMenu,
      href = _a.href;

  var computePaddingTop = function computePaddingTop() {
    return ratio[1] / ratio[0] * 100 + "%";
  }; // Used to add data-id to topIcons


  var enrichTopIconsWithDataId = React__default.Children.map(topIcons, function (child) {
    // @ts-ignore
    return React__default.cloneElement(child, {
      'data-id': id
    });
  });
  return React__default.createElement("div", {
    className: classNames(styles$6.container, className)
  }, React__default.createElement("a", {
    href: "/catalog/" + slug + "?productIds=" + id,
    onClick: function onClick(e) {
      return !href && e.preventDefault();
    }
  }, React__default.createElement(antd.Card, {
    id: id,
    bordered: false,
    className: classNames(styles$6.card, (_b = {}, _b[styles$6.shadow] = shadow, _b)),
    bodyStyle: !title && !desc ? {
      padding: '0'
    } : inner ? {
      padding: '8px 0px'
    } : {
      padding: '18px 24px'
    },
    cover: React__default.createElement("div", {
      className: classNames(styles$6.coverContainer, (_c = {}, _c[styles$6.coverContainerSelected] = selected, _c))
    }, React__default.createElement("div", {
      className: styles$6.imageContainer,
      style: {
        paddingTop: computePaddingTop()
      }
    }, image ? React__default.createElement("img", {
      className: classNames(styles$6.image, (_d = {}, _d[styles$6.fit] = imgFit, _d)),
      alt: title,
      src: image,
      style: imgFit ? {
        backgroundColor: imgBgColor
      } : {}
    }) : React__default.createElement("div", {
      className: classNames(styles$6.image, styles$6.placeHolder)
    })), selectable && React__default.createElement("label", {
      className: classNames(styles$6.checkbox, (_e = {}, _e[styles$6.checkboxSelected] = selected, _e)),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, selected && React__default.createElement("div", {
      className: styles$6.checkMark
    }), React__default.createElement("input", {
      className: styles$6.sr,
      type: "checkbox",
      name: "card",
      onChange: onSelect ? onSelect : undefined,
      checked: selected
    }), React__default.createElement("span", {
      className: styles$6.sr
    }, title)), topIcons && React__default.createElement("div", {
      className: styles$6.icons,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, enrichTopIcons ? enrichTopIconsWithDataId : topIcons), hoverText && React__default.createElement("div", {
      className: styles$6.hoverText
    }, hoverText), collectionMenu && React__default.createElement("div", {
      className: styles$6.collectionMenu,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, collectionMenu))
  }, React__default.createElement("div", {
    className: styles$6.info
  }, React__default.createElement("div", {
    className: styles$6.presentation
  }, title && React__default.createElement("div", {
    className: classNames(styles$6.title, (_f = {}, _f[styles$6.white] = theme === exports.Theme.WHITE, _f))
  }, title), desc && React__default.createElement("div", {
    className: classNames(styles$6.desc, (_g = {}, _g[styles$6.white] = theme === exports.Theme.WHITE, _g))
  }, desc), secondName && React__default.createElement("div", {
    className: classNames(styles$6.second, (_h = {}, _h[styles$6.white] = theme === exports.Theme.WHITE, _h))
  }, secondName), footer && React__default.createElement("div", {
    className: classNames(styles$6.footer, (_j = {}, _j[styles$6.white] = theme === exports.Theme.WHITE, _j))
  }, footer)), React__default.createElement("div", {
    className: classNames(styles$6.side, (_k = {}, _k[styles$6.white] = theme === exports.Theme.WHITE, _k))
  }, side || '')))));
};

Card.defaultProps = {
  desc: '',
  image: null,
  shadow: false,
  selectable: false,
  selected: false,
  onSelect: null,
  inner: false,
  ratio: [7, 5],
  className: '',
  hoverText: '',
  side: null,
  topIcons: null
};
var styles$7 = {
  "container": "InvisibleButton-module_container__3svpn"
};

var InvisibleButton = function InvisibleButton(_a) {
  var children = _a.children,
      className = _a.className,
      restProps = __rest(_a, ["children", "className"]);

  return React__default.createElement("button", _assign({
    className: classNames(styles$7.container, className)
  }, restProps), children);
};

var styles$8 = {
  "loadingContainer": "Loading-module_loadingContainer__NvrBK",
  "loading": "Loading-module_loading__K0SMQ"
};

var Loading = function Loading(_a) {
  var subtitle = _a.subtitle;
  return React__default.createElement("div", {
    className: styles$8.loadingContainer
  }, React__default.createElement(Icon, {
    className: styles$8.loading,
    type: "loading"
  }), subtitle && React__default.createElement(Heading, {
    level: 3
  }, subtitle));
};

var styles$9 = {
  "container": "SelectedNumber-module_container__HgCqM",
  "fixedBottom": "SelectedNumber-module_fixedBottom__3gvyf",
  "content": "SelectedNumber-module_content__2J414",
  "selectedNumberContainer": "SelectedNumber-module_selectedNumberContainer__Xe8Ne",
  "selectedNumberCircle": "SelectedNumber-module_selectedNumberCircle__2vYfR",
  "selectedNumberValue": "SelectedNumber-module_selectedNumberValue__RmgF0",
  "selectedNumberText": "SelectedNumber-module_selectedNumberText__1IEPe",
  "buttonsContainer": "SelectedNumber-module_buttonsContainer__115nA"
};

var SelectedNumber = function SelectedNumber(_a) {
  var _b;

  var selectedNumber = _a.selectedNumber,
      selectedNumberText = _a.selectedNumberText,
      selectedNumberPluralText = _a.selectedNumberPluralText,
      firstButton = _a.firstButton,
      secondButton = _a.secondButton,
      fixedBottom = _a.fixedBottom;
  return React__default.createElement("div", {
    className: classNames(styles$9.container, (_b = {}, _b[styles$9.fixedBottom] = fixedBottom, _b))
  }, React__default.createElement("div", {
    className: styles$9.content
  }, React__default.createElement("div", {
    className: styles$9.selectedNumberContainer
  }, React__default.createElement("div", {
    className: styles$9.selectedNumberCircle
  }, React__default.createElement("div", {
    className: styles$9.selectedNumberValue
  }, selectedNumber)), React__default.createElement("div", {
    className: styles$9.selectedNumberText
  }, selectedNumber > 1 ? selectedNumberPluralText : selectedNumberText)), React__default.createElement("div", {
    className: styles$9.buttonsContainer
  }, firstButton, secondButton)));
};

SelectedNumber.defaultProps = {
  fixedBottom: true
};
var styles$a = {
  "container": "CardGrid-module_container__3T8T4",
  "hasSelectedCards": "CardGrid-module_hasSelectedCards__v5ODJ",
  "gridItem": "CardGrid-module_gridItem__1E6hc",
  "card": "CardGrid-module_card__1tLYm",
  "noMatchItem": "CardGrid-module_noMatchItem__1C-Mq",
  "textCenter": "CardGrid-module_textCenter__2Nvjy"
};
var SCROLL_DELTA_TRIGGER = 400;

var CardGrid =
/** @class */
function (_super) {
  __extends(CardGrid, _super);

  function CardGrid(props) {
    var _this = _super.call(this, props) || this;

    _this.handleCardSelect = function (cardData) {
      var onCardSelect = _this.props.onCardSelect;
      var selectedCards = _this.state.selectedCards;
      var newSelectedCards = [];

      if (selectedCards.findIndex(function (item) {
        return item.id === cardData.id;
      }) !== -1) {
        newSelectedCards = selectedCards.filter(function (item) {
          return item.id !== cardData.id;
        });

        _this.setState({
          selectedCards: newSelectedCards
        });
      } else {
        newSelectedCards = selectedCards.concat([cardData]);

        _this.setState({
          selectedCards: newSelectedCards
        });
      }

      if (onCardSelect) {
        onCardSelect(newSelectedCards);
      }
    };

    _this.scrollHandler = function () {
      var _a = _this.props,
          loading = _a.loading,
          onScrolledBottom = _a.onScrolledBottom;

      if (onScrolledBottom && !loading && window.innerHeight + window.pageYOffset >= document.body.scrollHeight - SCROLL_DELTA_TRIGGER) {
        onScrolledBottom();
      }
    };

    var selectable = props.selectable,
        initialSelectedCards = props.initialSelectedCards,
        onCardSelect = props.onCardSelect;

    if (selectable && initialSelectedCards && onCardSelect) {
      _this.state = {
        selectedCards: initialSelectedCards ? initialSelectedCards : []
      };
      onCardSelect(initialSelectedCards);
    } else {
      _this.state = {
        selectedCards: []
      };
    }

    _this.handleCardSelect = _this.handleCardSelect.bind(_this);
    _this.scrollHandler = _this.scrollHandler.bind(_this);
    return _this;
  }

  CardGrid.prototype.componentDidMount = function () {
    var onScrolledBottom = this.props.onScrolledBottom;

    if (onScrolledBottom) {
      window.addEventListener('scroll', this.scrollHandler);
    }
  };

  CardGrid.prototype.componentWillUnmount = function () {
    var onScrolledBottom = this.props.onScrolledBottom;

    if (onScrolledBottom) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  };

  CardGrid.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        cardsData = _b.cardsData,
        onCardClick = _b.onCardClick,
        loading = _b.loading,
        scrollLoading = _b.scrollLoading,
        renderTopIcons = _b.renderTopIcons,
        className = _b.className,
        _c = _b.displaySelectedNumber,
        displaySelectedNumber = _c === void 0 ? true : _c,
        collectionMenu = _b.collectionMenu,
        loadingMessage = _b.loadingMessage,
        props = __rest(_b, ["cardsData", "onCardClick", "loading", "scrollLoading", "renderTopIcons", "className", "displaySelectedNumber", "collectionMenu", "loadingMessage"]);

    var selectedCards = this.state.selectedCards;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      className: classNames(styles$a.container, className, (_a = {}, _a[styles$a.hasSelectedCards] = selectedCards.length, _a))
    }, !loading && cardsData.length > 0 && cardsData.map(function (cardData) {
      return React__default.createElement(InvisibleButton, {
        key: cardData.id,
        onClick: onCardClick ? function () {
          return onCardClick(cardData);
        } : undefined,
        className: styles$a.gridItem
      }, React__default.createElement(Card, _assign({}, props, cardData, {
        className: styles$a.card,
        selected: selectedCards.findIndex(function (item) {
          return item.id === cardData.id;
        }) !== -1,
        onSelect: function onSelect() {
          return _this.handleCardSelect(cardData);
        },
        topIcons: renderTopIcons ? renderTopIcons(cardData) : null,
        collectionMenu: collectionMenu ? collectionMenu(cardData) : null
      })));
    })), !loading && cardsData.length === 0 && React__default.createElement("div", {
      className: styles$a.noMatchItem
    }, "Sorry, your search did not match any products."), loading && React__default.createElement("div", {
      className: styles$a.textCenter
    }, loadingMessage ? loadingMessage : 'Please wait while we are loading the largest 3D furniture collection available...', React__default.createElement("div", null, React__default.createElement(Loading, null))), scrollLoading && React__default.createElement(Loading, null), displaySelectedNumber && selectedCards.length ? React__default.createElement(SelectedNumber, _assign({
      selectedNumber: selectedCards.length
    }, props, {
      fixedBottom: true
    })) : null);
  };

  CardGrid.defaultProps = {
    selectedNumberText: '',
    selectedNumberPluralText: '',
    firstButton: null,
    secondButton: null,
    onScrolledBottom: null,
    onCardClick: null,
    onCardSelect: null,
    loading: false,
    shadow: false,
    selectable: false,
    inner: false,
    ratio: [7, 5],
    hoverText: '',
    side: null,
    renderTopIcons: null,
    scrollLoading: false,
    className: '',
    collectionMenu: null
  };
  return CardGrid;
}(React.Component); // use on your div element like this: <div ref={scrollContainerRef} onWheel={handleWheel} />


var useHorizontalScroll = function useHorizontalScroll() {
  var scrollContainerRef = React.useRef(null);

  var handleWheel = function handleWheel(e) {
    return scrollContainerRef.current && scrollContainerRef.current.scrollBy(e.deltaY, 0);
  };

  return {
    scrollContainerRef: scrollContainerRef,
    handleWheel: handleWheel
  };
};

var styles$b = {
  "container": "Carousel-module_container__1gREX",
  "top": "Carousel-module_top__2OjYt",
  "icons": "Carousel-module_icons__2u7NR",
  "carousel": "Carousel-module_carousel__jxBPR",
  "motionContainer": "Carousel-module_motionContainer__3vu_W",
  "imageContainer": "Carousel-module_imageContainer__1YU9s",
  "loadingContainer": "Carousel-module_loadingContainer__2dcun",
  "img": "Carousel-module_img__2uaJK",
  "description": "Carousel-module_description__feTUu",
  "renderIcons": "Carousel-module_renderIcons__9kz_7",
  "textContainer": "Carousel-module_textContainer__H0ksD",
  "title": "Carousel-module_title__lox5Y",
  "subtitle": "Carousel-module_subtitle__YMk06",
  "bottom": "Carousel-module_bottom__1asZJ",
  "imgContainer": "Carousel-module_imgContainer__28V4B",
  "image": "Carousel-module_image__1wMN2",
  "selected": "Carousel-module_selected__1YiXV"
};
var variants = {
  enter: function enter(direction) {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: function exit(direction) {
    return {
      zIndex: -1,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  }
};
var swipeConfidenceThreshold = 10000;

var swipePower = function swipePower(offset, velocity) {
  return Math.abs(offset) * velocity;
};

var CustomCarousel = React.forwardRef(function (_a, ref) {
  var imagesUrl = _a.imagesUrl,
      className = _a.className,
      renderIcons = _a.renderIcons;
  var containerRef = React.useRef(null);

  var _b = React.useState([0, 0]),
      _c = _b[0],
      page = _c[0],
      direction = _c[1],
      setPage = _b[1];

  var imageIndex = popcorn.wrap(0, imagesUrl.length, page);

  var _d = React.useState(true),
      loading = _d[0],
      setLoading = _d[1];

  var imagesRefs = React.useState(imagesUrl.map(function (el) {
    return React__default.createRef();
  }))[0];

  var _e = useHorizontalScroll(),
      scrollContainerRef = _e.scrollContainerRef,
      handleWheel = _e.handleWheel;

  React.useEffect(function () {
    if (imagesRefs[imageIndex] && imagesRefs[imageIndex].current) imagesRefs[imageIndex].current.scrollIntoView();
  }, [imageIndex]);

  var paginate = function paginate(newDirection) {
    setPage([page + newDirection, newDirection]);
  };

  var _goTo = function goTo(slide) {
    setPage([slide, page < slide ? 1 : -1]);
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 39) {
      paginate(1);
    } else if (e.keyCode === 37) {
      paginate(-1);
    }
  };

  React.useEffect(function () {
    window.addEventListener('keydown', handleKeyPress);
    return function () {
      window.removeEventListener('keydown', handleKeyPress);
    };
  });
  React.useImperativeHandle(ref, function () {
    return {
      goTo: function goTo(slide) {
        _goTo(slide);
      },
      focus: function focus() {
        containerRef && containerRef.current && containerRef.current.focus();
      }
    };
  });
  return React__default.createElement("div", {
    className: styles$b.container + " " + className,
    ref: containerRef,
    tabIndex: 0
  }, React__default.createElement("div", {
    className: styles$b.top
  }, React__default.createElement(antd.Icon, {
    type: "left",
    onClick: function onClick() {
      paginate(-1);
    },
    className: styles$b.icons
  }), React__default.createElement("div", {
    className: styles$b.carousel
  }, React__default.createElement(framerMotion.AnimatePresence, {
    initial: false,
    custom: direction
  }, React__default.createElement(framerMotion.motion.div, {
    key: page,
    custom: direction,
    variants: variants,
    initial: "enter",
    animate: "center",
    className: styles$b.motionContainer,
    exit: "exit",
    transition: {
      x: {
        type: 'spring',
        stiffness: 300,
        damping: 200
      },
      opacity: {
        duration: 0.2
      }
    },
    drag: "x",
    dragConstraints: {
      left: 0,
      right: 0
    },
    dragElastic: 1,
    onDragEnd: function onDragEnd(e, _a) {
      var offset = _a.offset,
          velocity = _a.velocity;
      var swipe = swipePower(offset.x, velocity.x);

      if (swipe < -swipeConfidenceThreshold) {
        paginate(1);
      } else if (swipe > swipeConfidenceThreshold) {
        paginate(-1);
      }
    }
  }, React__default.createElement("div", {
    className: styles$b.imageContainer
  }, loading && React__default.createElement("div", {
    className: styles$b.loadingContainer
  }, React__default.createElement(Loading, null)), React__default.createElement(reactLazyLoadImageComponent.LazyLoadImage, {
    src: imagesUrl[imageIndex].displayUrl,
    className: styles$b.img,
    beforeLoad: function beforeLoad() {
      return setLoading(true);
    },
    afterLoad: function afterLoad() {
      return setLoading(false);
    }
  })), React__default.createElement("div", {
    className: styles$b.description
  }, React__default.createElement("div", {
    className: styles$b.textContainer,
    key: imageIndex + 'textContainer'
  }, imagesUrl[imageIndex].title && React__default.createElement("div", {
    className: styles$b.title,
    key: imageIndex + 'title'
  }, imagesUrl[imageIndex].title), imagesUrl[imageIndex].subtitle && React__default.createElement("div", {
    className: styles$b.subtitle,
    key: imageIndex + 'subtitle'
  }, imagesUrl[imageIndex].subtitle)), renderIcons && React__default.createElement("div", {
    className: styles$b.renderIcons
  }, renderIcons(imagesUrl[imageIndex])))))), React__default.createElement(antd.Icon, {
    type: "right",
    onClick: function onClick() {
      paginate(1);
    },
    className: styles$b.icons
  })), React__default.createElement("div", {
    className: styles$b.bottom,
    ref: scrollContainerRef,
    onWheel: function onWheel() {
      return handleWheel;
    }
  }, imagesUrl.map(function (image, index) {
    return React__default.createElement("div", {
      className: styles$b.imgContainer,
      key: index,
      ref: imagesRefs[index]
    }, React__default.createElement(reactLazyLoadImageComponent.LazyLoadImage, {
      src: image.thumbnailUrl,
      className: styles$b.image + " " + (imageIndex === index ? styles$b.selected : ''),
      key: index,
      onClick: function onClick() {
        setPage([index, page < index ? 1 : -1]);
      }
    }));
  })));
});
var styles$c = {
  "container": "ConnectionView-module_container__xPR4U",
  "login": "ConnectionView-module_login__THCQ6",
  "title": "ConnectionView-module_title__1BPVJ",
  "desc": "ConnectionView-module_desc__VuNIu",
  "footer": "ConnectionView-module_footer__2SfmJ",
  "background": "ConnectionView-module_background__2S2vN"
};

var ConnectionView = function ConnectionView(_a) {
  var children = _a.children,
      title = _a.title,
      desc = _a.desc,
      footer = _a.footer,
      background = _a.background,
      logo = _a.logo;
  return React__default.createElement("div", {
    className: styles$c.container
  }, React__default.createElement("div", {
    className: styles$c.login
  }, React__default.createElement("img", {
    alt: "Logo",
    title: "Logo",
    src: logo
  }), React__default.createElement("h1", {
    className: styles$c.title
  }, title), React__default.createElement("p", {
    className: styles$c.desc
  }, desc), children, React__default.createElement("div", {
    className: styles$c.footer
  }, footer)), React__default.createElement("div", {
    className: styles$c.background
  }, React__default.createElement("img", {
    alt: "Logo",
    title: "Logo",
    src: background
  })));
};

var styles$d = {
  "container": "Container-module_container__3KHiT"
};

var Container = function Container(props) {
  return React__default.createElement("div", _assign({}, props, {
    className: styles$d.container + " " + (props.className || '')
  }), props.children);
};

var styles$e = {
  "contentContainer": "ContentContainer-module_contentContainer__2vBJB"
};

var ContentContainer = function ContentContainer(props) {
  return React__default.createElement("div", _assign({}, props, {
    className: styles$e.contentContainer + " " + (props.className || '')
  }), props.children);
};

var styles$f = {
  "container": "ColorButton-module_container__3gYkh",
  "selected": "ColorButton-module_selected__1IgRM",
  "color": "ColorButton-module_color__3cEeG",
  "transparency": "ColorButton-module_transparency__3R0Yy",
  "name": "ColorButton-module_name__3o7VW",
  "nameNew": "ColorButton-module_nameNew__2Wobr"
};

var ColorButton = function ColorButton(_a) {
  // we need to have this weird ternary
  // because ant doesn't display the tooltip if it is set to undefined
  var _b = _a.selected,
      selected = _b === void 0 ? false : _b,
      color = _a.color,
      onClick = _a.onClick,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      newName = _a.newName,
      _d = _a.showName,
      showName = _d === void 0 ? false : _d,
      defaultColorImg = _a.defaultColorImg;
  return React__default.createElement("div", {
    className: className
  }, React__default.createElement(antd.Tooltip, _assign({
    title: color.name
  }, showName ? {
    visible: false
  } : {}), React__default.createElement("button", {
    className: styles$f.container + " " + (selected ? styles$f.selected : ''),
    onClick: onClick
  }, React__default.createElement("div", {
    className: styles$f.color,
    style: {
      backgroundColor: color.hexa
    }
  }, color.hexa === '' && React__default.createElement("img", {
    src: defaultColorImg,
    className: styles$f.transparency
  })))), showName ? React__default.createElement("div", {
    className: newName ? styles$f.nameNew : styles$f.name
  }, color.name) : '');
};

var styles$g = {
  "dropdown": "DatePicker-module_dropdown__3WkRb",
  "container": "DatePicker-module_container__2md8F",
  "ant-input-disabled": "DatePicker-module_ant-input-disabled__3c4St"
};

var DatePicker = function DatePicker(_a) {
  var _b = _a.suffixIcon,
      suffixIcon = _b === void 0 ? React.createElement(Icon, {
    type: "caret-down"
  }) : _b,
      restProps = __rest(_a, ["suffixIcon"]);

  return React.createElement(AntDatePicker, _assign({
    className: styles$g.container,
    dropdownClassName: styles$g.dropdown,
    suffixIcon: suffixIcon,
    locale: locale
  }, restProps));
};

var styles$h = {
  "dropdown": "DateRangePicker-module_dropdown__qh2ym",
  "container": "DateRangePicker-module_container__34HFE"
};
var RangePicker = AntDatePicker.RangePicker;

var DateRangePicker = function DateRangePicker(_a) {
  var _b = _a.separator,
      separator = _b === void 0 ? '-' : _b,
      _c = _a.suffixIcon,
      suffixIcon = _c === void 0 ? React.createElement(Icon, {
    type: "caret-down"
  }) : _c,
      _d = _a.className,
      className = _d === void 0 ? '' : _d,
      restProps = __rest(_a, ["separator", "suffixIcon", "className"]);

  return React.createElement(RangePicker, _assign({
    className: styles$h.container + " " + className,
    dropdownClassName: styles$h.dropdown,
    suffixIcon: suffixIcon,
    separator: separator,
    locale: locale
  }, restProps));
};

var styles$i = {
  "container": "Diagram-module_container__3GU0d",
  "labelContainer": "Diagram-module_labelContainer__36ooj",
  "label": "Diagram-module_label__3k8ea",
  "subLabel": "Diagram-module_subLabel__n8ryU",
  "labelButton": "Diagram-module_labelButton__1zwcC",
  "diagram": "Diagram-module_diagram__1AyOw",
  "dark": "Diagram-module_dark__32e8H"
};
var Diagram = React__default.memo(function (_a) {
  var label = _a.label,
      subLabel = _a.subLabel,
      datas = _a.datas,
      _b = _a.integration,
      integration = _b === void 0 ? exports.Integration.LIGHT : _b,
      onClick = _a.onClick;
  var canvasRef = React.useRef(null);
  var chart;
  React__default.useEffect(function () {
    var ctx = canvasRef.current && canvasRef.current.getContext('2d');
    if (!ctx) return;
    chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: datas.map(function (data) {
            return data.value;
          }),
          borderWidth: 0,
          backgroundColor: datas.map(function (data) {
            return data.color;
          })
        }],
        labels: datas.map(function (data) {
          return data.label;
        })
      },
      options: {
        cutoutPercentage: 92,
        legend: {
          display: false
        },
        animation: {
          duration: 0
        }
      }
    });
    return function () {
      chart.destroy();
    };
  }, [datas]);
  var labelContent = React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
    className: styles$i.label
  }, label), subLabel && React__default.createElement("span", {
    className: styles$i.subLabel
  }, subLabel));
  return React__default.createElement("div", {
    className: styles$i.container + " " + styles$i[integration]
  }, React__default.createElement("div", {
    className: styles$i.labelContainer
  }, onClick ? React__default.createElement(InvisibleButton, {
    onClick: onClick,
    className: styles$i.labelButton
  }, labelContent) : React__default.createElement(InvisibleButton, {
    className: styles$i.labelButton
  }, labelContent)), React__default.createElement("canvas", {
    className: styles$i.diagram,
    ref: canvasRef,
    width: "150",
    height: "150"
  }));
});
var styles$j = {
  "formulaCard": "FormulaCard-module_formulaCard__3YV2T",
  "highlight": "FormulaCard-module_highlight__I8Kcw",
  "featureIcon": "FormulaCard-module_featureIcon__3lJkD",
  "header": "FormulaCard-module_header__1VAyu",
  "name": "FormulaCard-module_name__2mDE2",
  "price": "FormulaCard-module_price__1a-kU",
  "content": "FormulaCard-module_content__2L8rA",
  "features": "FormulaCard-module_features__1d5RS",
  "choose": "FormulaCard-module_choose__1l2L0"
};

var FormulaCard = function FormulaCard(_a) {
  var name = _a.name,
      price = _a.price,
      description = _a.description,
      features = _a.features,
      highlight = _a.highlight,
      onClick = _a.onClick;
  return React__default.createElement("div", {
    className: styles$j.formulaCard + " " + (highlight ? styles$j.highlight : '')
  }, React__default.createElement("div", {
    className: styles$j.header
  }, React__default.createElement("span", {
    className: styles$j.name
  }, name), React__default.createElement("span", {
    className: styles$j.price
  }, price, "\u20AC"), React__default.createElement("span", null, description)), React__default.createElement("div", {
    className: styles$j.content
  }, React__default.createElement("strong", null, name, " Features"), React__default.createElement("ul", {
    className: styles$j.features
  }, features.map(function (feature) {
    return React__default.createElement("li", null, React__default.createElement(antd.Icon, {
      type: "check",
      className: styles$j.featureIcon
    }), feature);
  }))), React__default.createElement(Button, {
    className: styles$j.choose,
    onClick: onClick,
    theme: highlight ? exports.Theme.WHITE : exports.Theme.PRIMARY,
    uppercase: true,
    block: true,
    size: exports.Size.LARGE
  }, "Choisir"));
};

var useClickOutside = function useClickOutside(ref, onClickOutside) {
  var handleClickOutside = function handleClickOutside(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      onClickOutside(e);
    }
  };

  React.useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
};

var styles$k = {
  "h1": "Heading-module_h1__1KFSB",
  "h2": "Heading-module_h2__3U4qc",
  "h3": "Heading-module_h3__1cfXa",
  "h4": "Heading-module_h4__2QFnY",
  "strong": "Heading-module_strong__3kwhB",
  "input": "Heading-module_input__2UsUw",
  "headingWrapper": "Heading-module_headingWrapper__GOQsR",
  "fill": "Heading-module_fill__2gLo-",
  "centerText": "Heading-module_centerText__2OZcT",
  "icon": "Heading-module_icon__1BEDf"
};

var Heading = function Heading(_a) {
  var _b, _c;

  var level = _a.level,
      children = _a.children,
      _d = _a.className,
      className = _d === void 0 ? '' : _d,
      strong = _a.strong,
      onEdit = _a.onEdit,
      as = _a.as,
      fill = _a.fill,
      centerText = _a.centerText;

  var _e = React.useState(false),
      editing = _e[0],
      setEditing = _e[1];

  var wrapperRef = React.useRef(null);

  var _f = React.useState(''),
      editedValue = _f[0],
      setEditedValue = _f[1];

  React.useEffect(function () {
    setEditedValue(children);
  }, [children]);

  var onClickOutside = function onClickOutside() {
    if (editing) {
      setEditing(false);

      if (editedValue !== children) {
        onEdit && onEdit(editedValue);
      }
    }
  };

  var handleKeys = function handleKeys(e) {
    if (e.keyCode === 13) {
      setEditing(false);

      if (editedValue !== children) {
        onEdit && onEdit(editedValue);
      }
    }

    if (e.keyCode === 27) {
      setEditing(false);
    }
  };

  var handleClick = React.useCallback(function () {
    if (!editing && onEdit) {
      setEditing(true);
    }
  }, [editing, onEdit]);
  useClickOutside(wrapperRef, onClickOutside);
  return React__default.createElement("div", {
    className: classNames(styles$k.headingWrapper, (_b = {}, _b[styles$k.fill] = fill, _b[styles$k.centerText] = centerText, _b)),
    onClick: handleClick,
    ref: wrapperRef
  }, !editing && React__default.createElement(as || "h" + level, {
    className: classNames(styles$k["h" + level], className, (_c = {}, _c[styles$k.strong] = strong, _c))
  }, editedValue), editing && React__default.createElement("input", {
    className: styles$k["h" + level] + " " + styles$k.input,
    type: "text",
    autoFocus: true,
    defaultValue: children,
    onKeyDown: handleKeys,
    onChange: function onChange(e) {
      setEditedValue(e.target.value);
    }
  }), onEdit && React__default.createElement(antd.Icon, {
    type: "edit",
    className: styles$k["h" + level] + " " + styles$k.icon
  }));
};

var styles$l = {
  "fullWidthTabs": "Tabs-module_fullWidthTabs__1yrtN",
  "tabs": "Tabs-module_tabs__1of6Y"
};

var TabPane = function TabPane(props) {
  return React__default.createElement(AntdTabs.TabPane, _assign({}, props, {
    className: styles$l.tabPane
  }), props.children);
};

var Tabs =
/** @class */
function (_super) {
  __extends(Tabs, _super);

  function Tabs() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tabs.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        fullWidth = _a.fullWidth,
        rest = __rest(_a, ["className", "children", "fullWidth"]);

    return React__default.createElement(AntdTabs, _assign({
      animated: false,
      className: styles$l.tabs + " " + className + " " + (fullWidth && styles$l.fullWidthTabs)
    }, rest), children);
  };

  Tabs.TabPane = TabPane;
  return Tabs;
}(React.Component);

var styles$m = {
  "container": "UserMenu-module_container__3hI1s",
  "avatarContainer": "UserMenu-module_avatarContainer__3ntsx",
  "avatar": "UserMenu-module_avatar__-xl8q",
  "defaultAvatar": "UserMenu-module_defaultAvatar__2tw_r",
  "userName": "UserMenu-module_userName__1YQAB"
};

var UserMenu = function UserMenu(_a) {
  var userMenu = _a.userMenu,
      defaultProfilePictureUrl = _a.defaultProfilePictureUrl,
      profilePictureUrl = _a.profilePictureUrl,
      firstName = _a.firstName,
      lastName = _a.lastName;
  return React__default.createElement(Dropdown, {
    overlay: userMenu,
    trigger: ['click'],
    placement: "bottomRight"
  }, React__default.createElement("div", {
    className: styles$m.container
  }, React__default.createElement("div", {
    className: styles$m.avatarContainer
  }, React__default.createElement("div", {
    className: styles$m.avatar
  }, profilePictureUrl || defaultProfilePictureUrl ? React__default.createElement("img", {
    src: profilePictureUrl || defaultProfilePictureUrl,
    alt: "Menu Utilisateur"
  }) : React__default.createElement("div", {
    className: styles$m.defaultAvatar
  })), React__default.createElement(Icon, {
    type: "caret-down",
    style: {
      fontSize: 12,
      marginLeft: '8px'
    }
  })), firstName && lastName && React__default.createElement("div", {
    className: styles$m.userName
  }, firstName && lastName ? firstName + " " + lastName : null)));
};

var styles$n = {
  "header": "Header-module_header__2gV_n",
  "top": "Header-module_top__2vVSt",
  "navigation": "Header-module_navigation__3_1kg",
  "logo": "Header-module_logo__2Zf4H",
  "defaultLogo": "Header-module_defaultLogo__8i6hH",
  "breadcrumb": "Header-module_breadcrumb__Ch3zX",
  "userMenu": "Header-module_userMenu__2XxNW",
  "content": "Header-module_content__2DdbC",
  "title": "Header-module_title__3JWMg",
  "tabs": "Header-module_tabs__1CyVm",
  "addButtonContainer": "Header-module_addButtonContainer__2shpL",
  "addButton": "Header-module_addButton__3xa0W"
};

var Header = function Header(_a) {
  var breadcrumbRoutes = _a.breadcrumbRoutes,
      breadcrumbProps = _a.breadcrumbProps,
      logoUrl = _a.logoUrl,
      title = _a.title,
      tabs = _a.tabs,
      activeTabKey = _a.activeTabKey,
      onTabChange = _a.onTabChange,
      addButtonTitle = _a.addButtonTitle,
      onAddButtonClick = _a.onAddButtonClick,
      onLogoClick = _a.onLogoClick,
      onEdit = _a.onEdit,
      props = __rest(_a, ["breadcrumbRoutes", "breadcrumbProps", "logoUrl", "title", "tabs", "activeTabKey", "onTabChange", "addButtonTitle", "onAddButtonClick", "onLogoClick", "onEdit"]);

  return React__default.createElement("div", {
    className: styles$n.header
  }, React__default.createElement("div", {
    className: styles$n.top
  }, React__default.createElement("div", {
    className: styles$n.navigation
  }, React__default.createElement(InvisibleButton, {
    className: styles$n.logo,
    onClick: onLogoClick
  }, logoUrl ? React__default.createElement("img", {
    src: logoUrl,
    alt: "logo",
    title: "logo"
  }) : React__default.createElement("div", {
    className: styles$n.defaultLogo
  })), React__default.createElement("div", {
    className: styles$n.breadcrumb
  }, React__default.createElement(Breadcrumb, _assign({
    routes: breadcrumbRoutes
  }, breadcrumbProps)))), React__default.createElement("div", {
    className: styles$n.userMenu
  }, React__default.createElement(UserMenu, _assign({}, props)))), title || tabs && activeTabKey && onTabChange ? React__default.createElement("div", {
    className: styles$n.content
  }, React__default.createElement(ContentContainer, null, title && React__default.createElement("div", {
    className: styles$n.title
  }, React__default.createElement(Heading, {
    level: 2,
    as: "h1",
    strong: true,
    onEdit: onEdit
  }, title)), tabs && activeTabKey && onTabChange && React__default.createElement(Tabs, {
    activeKey: activeTabKey,
    animated: {
      inkBar: false,
      tabPane: false
    },
    size: "small",
    className: styles$n.tabs,
    onChange: onTabChange
  }, tabs))) : null, onAddButtonClick && React__default.createElement("div", {
    className: styles$n.addButtonContainer
  }, React__default.createElement(ContentContainer, null, React__default.createElement(Button, {
    className: styles$n.addButton,
    uppercase: true,
    icon: "plus",
    shape: addButtonTitle ? 'round' : 'circle',
    theme: exports.Theme.PRIMARY,
    size: exports.Size.MEDIUM,
    role: "link",
    onClick: onAddButtonClick
  }, addButtonTitle))));
};

var styles$o = {
  "select": "PopOverMenu-module_select__27Exs"
};
var Option$1 = AntSelect.Option;

var PopOverMenu = function PopOverMenu(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.suffixIcon,
      suffixIcon = _c === void 0 ? React__default.createElement(Icon, {
    type: "caret-down"
  }) : _c,
      _d = _a.dropdownClassName,
      dropdownClassName = _d === void 0 ? '' : _d,
      restProps = __rest(_a, ["className", "suffixIcon", "dropdownClassName"]);

  return React__default.createElement(AntSelect, _assign({
    className: styles$o.select + " " + className,
    dropdownClassName: styles$o.dropdown + " " + dropdownClassName,
    suffixIcon: suffixIcon
  }, restProps));
};

var styles$p = {};
var Option$2 = AntSelect.Option;

var PopOverMenuItem = function PopOverMenuItem(_a) {
  var className = _a.className,
      restProps = __rest(_a, ["className"]);

  return React__default.createElement(Option$2, _assign({
    className: className + " " + styles$p.option
  }, restProps));
};

var styles$q = {
  "container": "Searchbar-module_container__135WH",
  "ant-input-disabled": "Searchbar-module_ant-input-disabled__3ubNx",
  "light": "Searchbar-module_light__3XVOq",
  "dark": "Searchbar-module_dark__2fVeI"
};

var Searchbar = function Searchbar(_a) {
  var _b = _a.integration,
      integration = _b === void 0 ? exports.Integration.LIGHT : _b,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      props = __rest(_a, ["integration", "className"]);

  return React__default.createElement(Input.Search, _assign({
    className: styles$q.container + " " + className + " " + styles$q[integration]
  }, props));
};

var styles$r = {
  "container": "InfiniteGridWithSearch-module_container__3JqeP",
  "searchBar": "InfiniteGridWithSearch-module_searchBar__33qG2",
  "filtersContainer": "InfiniteGridWithSearch-module_filtersContainer__2kCct",
  "order": "InfiniteGridWithSearch-module_order__3F4hT"
};

var InfiniteGridWithSearch = function InfiniteGridWithSearch(_a) {
  var title = _a.title,
      searchPlaceHolder = _a.searchPlaceHolder,
      cardsData = _a.cardsData,
      totalItems = _a.totalItems,
      filters = _a.filters,
      doInitialFetch = _a.doInitialFetch,
      fetchItems = _a.fetchItems,
      headerClassName = _a.headerClassName,
      searchBarClassName = _a.searchBarClassName,
      onSearchChange = _a.onSearchChange,
      loading = _a.loading,
      orderItems = _a.orderItems,
      customSearchbar = _a.customSearchbar,
      searchValueProps = _a.searchValue,
      loadingMessage = _a.loadingMessage,
      props = __rest(_a, ["title", "searchPlaceHolder", "cardsData", "totalItems", "filters", "doInitialFetch", "fetchItems", "headerClassName", "searchBarClassName", "onSearchChange", "loading", "orderItems", "customSearchbar", "searchValue", "loadingMessage"]);

  var _b = React.useState(''),
      searchValue = _b[0],
      setSearchValue = _b[1];

  var _c = React.useState(true),
      isLoading = _c[0],
      setIsLoading = _c[1];

  var _d = React.useState(false),
      scrollLoading = _d[0],
      setScrollLoading = _d[1];

  var _e = React.useState(false),
      initialFetch = _e[0],
      setInitialFetch = _e[1];

  var _f = React.useState(orderItems && orderItems.length > 0 ? orderItems[0] : undefined),
      orderItem = _f[0],
      setOrderItem = _f[1];

  React.useEffect(function () {
    if (searchValueProps) {
      setSearchValue(searchValueProps);
    } else {
      setSearchValue('');
    }
  }, [searchValueProps]);
  React.useEffect(function () {
    var timer;

    if ((doInitialFetch || initialFetch) && filters !== undefined) {
      setIsLoading(true);
      timer = setTimeout(function () {
        var _a;

        fetchItems(_assign({}, filters, {
          query: [searchValue]
        }), true, 0, orderItem ? (_a = {}, _a[orderItem.orderKey] = orderItem.order, _a) : undefined).then(function () {
          setIsLoading(false);
        });
      }, 500);
    }

    if (!initialFetch) {
      setInitialFetch(true);
    }

    return function () {
      clearTimeout(timer);
    };
  }, [doInitialFetch, filters, orderItem, searchValue]);
  var handleScrolledBottom = React.useCallback(function () {
    var _a;

    if (!scrollLoading && cardsData.length < totalItems) {
      setScrollLoading(true);
      fetchItems(_assign({}, filters, {
        query: [searchValue]
      }), false, cardsData.length, orderItem ? (_a = {}, _a[orderItem.orderKey] = orderItem.order, _a) : undefined).then(function () {
        setScrollLoading(false);
      });
    }
  }, [fetchItems, scrollLoading, cardsData, totalItems, filters, searchValue, orderItem]);
  var handleSearchChange = React.useCallback(function (newSearchValue) {
    if (onSearchChange) {
      onSearchChange(_assign({}, filters, {
        query: [newSearchValue]
      }));
    }

    setSearchValue(newSearchValue);
  }, [onSearchChange, filters]);
  return React__default.createElement("div", {
    className: styles$r.container
  }, React__default.createElement("div", {
    className: headerClassName
  }, title && React__default.createElement(Heading, {
    as: "h1",
    level: 3
  }, title), (customSearchbar || searchPlaceHolder || orderItems) && React__default.createElement("div", {
    className: styles$r.filtersContainer
  }, customSearchbar && React__default.createElement("div", {
    className: styles$r.searchBar
  }, customSearchbar), searchPlaceHolder && React__default.createElement(Searchbar, {
    className: classNames(styles$r.searchBar, searchBarClassName),
    placeholder: searchPlaceHolder,
    onSearch: handleSearchChange
  }), orderItems && React__default.createElement(PopOverMenu, {
    className: styles$r.order,
    onChange: function onChange(value) {
      var item = orderItems.find(function (i) {
        return i.id === value;
      });
      if (item) setOrderItem(item);
    },
    value: orderItem ? orderItem.label : ''
  }, orderItems.map(function (item) {
    return React__default.createElement(PopOverMenuItem, {
      value: item.id,
      key: item.id
    }, item.label);
  })))), React__default.createElement(CardGrid, _assign({}, props, {
    loadingMessage: loadingMessage,
    cardsData: cardsData,
    onScrolledBottom: handleScrolledBottom,
    loading: loading && isLoading,
    scrollLoading: scrollLoading
  })));
};

InfiniteGridWithSearch.defaultProps = {
  doInitialFetch: true,
  headerClassName: '',
  searchBarClassName: ''
};
var styles$s = {
  "inputNumber": "InputNumber-module_inputNumber__2TQ78"
};

var InputNumber = function InputNumber(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  var language = navigator && navigator.language.split(/[-_]/)[0];
  return React__default.createElement(AntInputNumber, _assign({
    type: "string"
  }, language === 'fr' ? {
    decimalSeparator: ','
  } : {}, props, {
    className: styles$s.inputNumber + " " + className
  }));
};

var styles$t = {
  "inputURL": "InputURL-module_inputURL__m1iLS",
  "icon": "InputURL-module_icon__3zsqS"
};

var InputURL = function InputURL(_a) {
  var className = _a.className,
      onChange = _a.onChange,
      value = _a.value,
      defaultValue = _a.defaultValue,
      props = __rest(_a, ["className", "onChange", "value", "defaultValue"]);

  var _b = React.useState(''),
      address = _b[0],
      setAddress = _b[1];

  var _c = React.useState(false),
      valid = _c[0],
      setValid = _c[1];

  React.useEffect(function () {
    var val = value || defaultValue || address;
    setAddress("" + val);
    if (val) setValid(true);
  }, [value, defaultValue]);
  var handleChange = React.useCallback(function (e) {
    var isValid = e.target.checkValidity();
    setValid(isValid);
    if (isValid) setAddress(e.target.value);
    if (onChange) onChange(e);
  }, [onChange]);
  return React__default.createElement(Input, _assign({}, props, {
    className: styles$t.inputURL + " " + className,
    onChange: handleChange
  }, value ? {
    value: value
  } : {}, defaultValue ? {
    defaultValue: defaultValue
  } : {}, {
    type: "url",
    pattern: ".+\\..+",
    addonAfter: valid && address ? React__default.createElement("a", {
      href: address,
      title: "Acc\xE9der",
      target: "_blank"
    }, React__default.createElement(antd.Icon, {
      type: "arrow-right"
    })) : React__default.createElement(antd.Icon, {
      type: "stop"
    })
  }));
};

var styles$u = {
  "itemPicker": "ItemPicker-module_itemPicker__1L1jA",
  "item": "ItemPicker-module_item__SI42T",
  "selected": "ItemPicker-module_selected__qDg43",
  "text": "ItemPicker-module_text__1mggs",
  "name": "ItemPicker-module_name__9WtjM",
  "description": "ItemPicker-module_description__3X-OR"
};

function ItemPicker(_a) {
  var values = _a.values,
      value = _a.value,
      name = _a.name,
      onChange = _a.onChange,
      itemPictureSrc = _a.itemPictureSrc,
      itemName = _a.itemName,
      itemDescription = _a.itemDescription;

  var handleChange = function handleChange(event) {
    var selected = values.find(function (v) {
      return v.id === event.target.value;
    });
    if (selected) onChange(selected);
  };

  return React__default.createElement("ul", {
    className: styles$u.itemPicker
  }, values.map(function (item) {
    var _a;

    return React__default.createElement("li", {
      key: item.id
    }, React__default.createElement("label", {
      className: classNames(styles$u.item, (_a = {}, _a[styles$u.selected] = value && value.id === item.id, _a))
    }, React__default.createElement("input", {
      type: "radio",
      value: item.id,
      name: name,
      checked: value && value.id === item.id,
      onChange: handleChange
    }), React__default.createElement("img", {
      src: itemPictureSrc(item),
      "aria-hidden": true
    }), React__default.createElement("div", {
      className: styles$u.text
    }, React__default.createElement("span", {
      className: styles$u.name
    }, itemName(item)), itemDescription && React__default.createElement("span", {
      className: styles$u.description
    }, itemDescription(item)))));
  }));
}

var styles$v = {
  "page": "Layout-module_page__uwxFk",
  "content": "Layout-module_content__23chO"
};

var Layout = function Layout(_a) {
  var className = _a.className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return React__default.createElement("div", {
    className: styles$v.page
  }, React__default.createElement(Header, _assign({}, props)), React__default.createElement("div", {
    className: classNames(className, styles$v.content)
  }, children));
};

Layout.defaultProps = {
  className: ''
};
var styles$w = {
  "container": "LoginLayout-module_container__2eMzE",
  "loginHeader": "LoginLayout-module_loginHeader__1llz4",
  "logo": "LoginLayout-module_logo__2d1HY",
  "pageTitle": "LoginLayout-module_pageTitle__3EBxs",
  "containerSection": "LoginLayout-module_containerSection__3OYAR",
  "containerSectionNoImage": "LoginLayout-module_containerSectionNoImage__3Mmu5",
  "content": "LoginLayout-module_content__3z7Gs",
  "presentation": "LoginLayout-module_presentation__3kfov",
  "footer": "LoginLayout-module_footer__1lACt"
};

var LoginLayout = function LoginLayout(_a) {
  var children = _a.children,
      logo = _a.logo,
      backgroundImage = _a.backgroundImage,
      pageTitle = _a.pageTitle,
      title = _a.title,
      subtitle = _a.subtitle,
      className = _a.className,
      footer = _a.footer,
      _b = _a.displayImage,
      displayImage = _b === void 0 ? true : _b;
  return React__default.createElement("div", {
    className: styles$w.container
  }, React__default.createElement("div", {
    className: displayImage ? styles$w.containerSection : styles$w.containerSectionNoImage
  }, displayImage && React__default.createElement("div", null, React__default.createElement("img", {
    src: backgroundImage
  })), React__default.createElement(Container, {
    className: classNames(styles$w.content, className)
  }, React__default.createElement("div", {
    className: styles$w.contentHeader
  }, React__default.createElement("h1", null, title), subtitle && React__default.createElement("p", {
    className: styles$w.presentation
  }, subtitle)), children)), React__default.createElement("div", {
    className: styles$w.footer
  }, footer));
};

var styles$x = {
  "modal": "Modal-module_modal__FqeFw"
};

var Modal = function Modal(_a) {
  var className = _a.className,
      onOk = _a.onOk,
      onCancel = _a.onCancel,
      cancelText = _a.cancelText,
      okText = _a.okText,
      okButtonProps = _a.okButtonProps,
      cancelButtonProps = _a.cancelButtonProps,
      footer = _a.footer,
      props = __rest(_a, ["className", "onOk", "onCancel", "cancelText", "okText", "okButtonProps", "cancelButtonProps", "footer"]);

  var defaultFooter = React__default.createElement(React__default.Fragment, null, React__default.createElement(Button, _assign({
    block: true,
    uppercase: true,
    size: exports.Size.LARGE
  }, cancelButtonProps, {
    onClick: onCancel
  }), cancelText || 'Cancel'), React__default.createElement(Button, _assign({
    block: true,
    uppercase: true,
    size: exports.Size.LARGE
  }, okButtonProps, {
    onClick: onOk,
    theme: exports.Theme.PRIMARY
  }), okText || 'OK'));
  return React__default.createElement(AntModal, _assign({}, props, {
    className: styles$x.modal + " " + (className || ''),
    onCancel: onCancel,
    onOk: onOk,
    footer: footer !== undefined ? footer : defaultFooter
  }));
};

var styles$y = {
  "select": "MultipleSelect-module_select__2k6lU",
  "dropdown": "MultipleSelect-module_dropdown__-5snl"
};
var Option$3 = AntSelect.Option;

var MultipleSelect = function MultipleSelect(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.suffixIcon,
      suffixIcon = _c === void 0 ? React__default.createElement(Icon, {
    type: "caret-down"
  }) : _c,
      _d = _a.dropdownClassName,
      dropdownClassName = _d === void 0 ? '' : _d,
      restProps = __rest(_a, ["className", "suffixIcon", "dropdownClassName"]);

  return React__default.createElement(AntSelect, _assign({}, restProps, {
    className: styles$y.select + " " + className,
    dropdownClassName: styles$y.dropdown + " " + dropdownClassName,
    mode: "multiple",
    suffixIcon: suffixIcon
  }));
};

var styles$z = {
  "overlay": "Popconfirm-module_overlay__uAKXg",
  "okButton": "Popconfirm-module_okButton__11RCX",
  "cancelButton": "Popconfirm-module_cancelButton__trBAl"
};

var Popconfirm = function Popconfirm(_a) {
  var children = _a.children,
      _b = _a.icon,
      icon = _b === void 0 ? React__default.createElement(React__default.Fragment, null) : _b,
      restProps = __rest(_a, ["children", "icon"]);

  return React__default.createElement(AntdPopConfirm, _assign({
    icon: icon
  }, restProps, {
    overlayClassName: styles$z.overlay,
    okButtonProps: {
      className: styles$z.okButton
    },
    cancelButtonProps: {
      className: styles$z.cancelButton
    }
  }), children);
};

var styles$A = {
  "container": "QuoteLine-module_container__pjEFP",
  "thumbnail": "QuoteLine-module_thumbnail__15z41",
  "infos": "QuoteLine-module_infos__3mL9d",
  "productName": "QuoteLine-module_productName__1a8nm",
  "brandName": "QuoteLine-module_brandName__3kX_p",
  "quantity": "QuoteLine-module_quantity__1EAyV",
  "price": "QuoteLine-module_price__3EWmZ"
};

var QuoteLine = function QuoteLine(_a) {
  var title = _a.title,
      picture = _a.picture,
      subtitle = _a.subtitle,
      quantity = _a.quantity,
      price = _a.price,
      quantityLabel = _a.quantityLabel,
      currencySymbol = _a.currencySymbol;
  return React__default.createElement("div", {
    className: styles$A.container
  }, React__default.createElement("div", {
    className: styles$A.thumbnail
  }, React__default.createElement("img", {
    src: picture
  })), React__default.createElement("div", {
    className: styles$A.infos
  }, React__default.createElement("span", {
    className: styles$A.productName
  }, title), React__default.createElement("span", {
    className: styles$A.brandName
  }, subtitle), React__default.createElement("span", {
    className: styles$A.quantity
  }, quantityLabel, ": ", quantity)), React__default.createElement("div", {
    className: styles$A.price
  }, price === 0 ? '-' : price.toFixed(2), " ", currencySymbol));
};

var styles$B = {
  "select": "Select-module_select__1qWxd",
  "dropdown": "Select-module_dropdown__20VO4"
};
var Option$4 = AntSelect.Option;

var Select = function Select(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.suffixIcon,
      suffixIcon = _c === void 0 ? React__default.createElement(Icon, {
    type: "caret-down"
  }) : _c,
      _d = _a.dropdownClassName,
      dropdownClassName = _d === void 0 ? '' : _d,
      restProps = __rest(_a, ["className", "suffixIcon", "dropdownClassName"]);

  return React__default.createElement(AntSelect, _assign({
    className: styles$B.select + " " + className,
    dropdownClassName: styles$B.dropdown + " " + dropdownClassName,
    suffixIcon: suffixIcon
  }, restProps));
};

var styles$C = {
  "steps": "Steps-module_steps__fW4Qq",
  "dot": "Steps-module_dot__3ABWC",
  "process": "Steps-module_process__24gSH",
  "finish": "Steps-module_finish__3CNYH"
};

var customDot = function customDot(dot, _a) {
  var status = _a.status;
  return React__default.createElement("span", {
    className: styles$C.dot + " " + styles$C[status || 'wait']
  }, status === 'finish' && React__default.createElement(antd.Icon, {
    type: "check"
  }));
};

var Steps =
/** @class */
function (_super) {
  __extends(Steps, _super);

  function Steps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Steps.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        props = __rest(_a, ["children", "className"]);

    return React__default.createElement(AntSteps, _assign({}, props, {
      progressDot: customDot,
      className: (className || '') + " " + styles$C.steps
    }), children);
  };

  Steps.Step = AntSteps.Step;
  return Steps;
}(React.Component);

var styles$D = {
  "switch": "Switch-module_switch__1m1Y0",
  "dark": "Switch-module_dark__1-vCb",
  "light": "Switch-module_light__2RbE8",
  "green": "Switch-module_green__1fGwX",
  "checkLabel": "Switch-module_checkLabel__3PWoU",
  "label": "Switch-module_label__1Mtfd"
};

var Switch = function Switch(_a) {
  var children = _a.children,
      _b = _a.integration,
      integration = _b === void 0 ? exports.Integration.LIGHT : _b,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      restProps = __rest(_a, ["children", "integration", "className"]);

  return React__default.createElement("div", {
    className: className
  }, children && React__default.createElement("label", {
    className: styles$D.label
  }, children), React__default.createElement(AntSwitch, _assign({
    checkedChildren: React__default.createElement("span", {
      className: styles$D.checkLabel
    }, "On"),
    unCheckedChildren: React__default.createElement("span", {
      className: styles$D.checkLabel
    }, "Off"),
    "aria-label": children,
    className: styles$D.switch + " " + styles$D[integration]
  }, restProps)));
};

var styles$E = {
  "container": "Table-module_container__2XRf2",
  "small": "Table-module_small__TEdkU",
  "large": "Table-module_large__3us2B",
  "row": "Table-module_row__3dW8Y",
  "cell": "Table-module_cell__39yzb",
  "row-header": "Table-module_row-header__1CsLB",
  "table": "Table-module_table__3C6Tf"
};

var Row = function Row(props) {
  return React__default.createElement("tr", _assign({}, props, {
    className: styles$E.row + " " + props.className
  }));
};

var RowHeader = function RowHeader(props) {
  return React__default.createElement("tr", _assign({}, props, {
    className: styles$E['row-header'] + " " + props.className
  }));
};

var Cell = function Cell(props) {
  return React__default.createElement("td", _assign({}, props, {
    className: styles$E.cell + " " + props.className
  }));
};

var components = {
  header: {
    row: RowHeader
  },
  body: {
    row: Row,
    cell: Cell
  }
};

function Table(props) {
  return React__default.createElement(AntTable, _assign({
    locale: {
      emptyText: props.childrenColumnName
    }
  }, props, {
    components: _assign({}, components, props.components),
    className: styles$E.table + " " + props.className
  }));
}

var styles$F = {
  "tag": "Tag-module_tag__1sqlq",
  "active": "Tag-module_active__2nRfg",
  "inactive": "Tag-module_inactive__Qc4tx",
  "danger": "Tag-module_danger__12Zry",
  "closable": "Tag-module_closable__3cBvs",
  "large": "Tag-module_large__1JkUt"
};

var Tag = function Tag(props) {
  var classNames = [styles$F.tag, styles$F[props.type || exports.TagType.ACTIVE], props.className];
  if (props.closable) classNames.push(styles$F.closable);
  if (props.size === exports.Size.LARGE) classNames.push(styles$F.large);
  return React__default.createElement(AntTag, _assign({}, props, {
    className: classNames.join(' ')
  }), props.children);
};

var styles$G = {
  "tagsList": "TagsList-module_tagsList__3RtvQ"
};

var TagsList = function TagsList(_a) {
  var values = _a.values,
      _onClose = _a.onClose;
  return React__default.createElement("ul", {
    className: styles$G.tagsList
  }, values.map(function (value, index) {
    return React__default.createElement("li", {
      key: index
    }, React__default.createElement(Tag, {
      closable: true,
      onClose: function onClose() {
        return _onClose(index);
      }
    }, value));
  }));
};

var styles$H = {
  "textarea": "TextArea-module_textarea__2BaSv"
};

var TextArea = function TextArea(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return React__default.createElement(AntTextArea, _assign({
    autosize: {
      minRows: 4
    }
  }, props, {
    className: styles$H.textarea + " " + (className || '')
  }));
};

var styles$I = {
  "container": "Thumbnail-module_container__2hH-k",
  "small": "Thumbnail-module_small__3Q9gt",
  "large": "Thumbnail-module_large__1PWyI"
};

var Thumbnail = function Thumbnail(_a) {
  var _b;

  var src = _a.src,
      alt = _a.alt,
      _c = _a.size,
      size = _c === void 0 ? exports.Size.MEDIUM : _c,
      className = _a.className;
  return React__default.createElement("div", {
    className: classNames(styles$I.container, (_b = {}, _b[styles$I.small] = size === exports.Size.SMALL, _b[styles$I.large] = size === exports.Size.LARGE, _b), className)
  }, React__default.createElement("img", {
    src: src,
    alt: alt
  }));
};

var styles$J = {
  "container": "SkeletonThumbnail-module_container__3AVJv",
  "small": "SkeletonThumbnail-module_small__uJ2l3",
  "large": "SkeletonThumbnail-module_large__t8w4u"
};

var SkeletonContentLoader = function SkeletonContentLoader(_a) {
  var className = _a.className,
      children = _a.children,
      height = _a.height,
      width = _a.width;
  return React__default.createElement(ContentLoader, {
    className: className,
    height: height,
    width: width,
    speed: 2,
    primaryColor: "#dadada",
    secondaryColor: "#ecebeb"
  }, children);
};

var _a;

var thumbnail_size = '4.267rem';
var thumbnail_small_size = '3.7rem';
var thumbnail_large_size = '6rem';
var skeletonThumbnailSize = (_a = {}, _a[exports.Size.SMALL] = thumbnail_small_size, _a[exports.Size.MEDIUM] = thumbnail_size, _a[exports.Size.LARGE] = thumbnail_large_size, _a);

var SkeletonThumbnail = function SkeletonThumbnail(_a) {
  var _b;

  var _c = _a.size,
      size = _c === void 0 ? exports.Size.MEDIUM : _c,
      className = _a.className;
  return React__default.createElement(SkeletonContentLoader, {
    className: classNames(styles$J.container, (_b = {}, _b[styles$J.small] = size === exports.Size.SMALL, _b[styles$J.large] = size === exports.Size.LARGE, _b), className),
    height: skeletonThumbnailSize[size],
    width: skeletonThumbnailSize[size]
  }, React__default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "3",
    ry: "3",
    width: skeletonThumbnailSize[size],
    height: skeletonThumbnailSize[size]
  }));
};

var SkeletonCard = function SkeletonCard(_a) {
  var className = _a.className,
      hideInfos = _a.hideInfos;
  return React__default.createElement(SkeletonContentLoader, {
    className: className,
    height: 340,
    width: 385
  }, !hideInfos ? React__default.createElement(React__default.Fragment, null, React__default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "8",
    ry: "8",
    width: "385",
    height: "275"
  }), React__default.createElement("rect", {
    x: "0",
    y: "283",
    rx: "4",
    ry: "4",
    width: "223",
    height: "24"
  }), React__default.createElement("rect", {
    x: "0",
    y: "315",
    rx: "4",
    ry: "4",
    width: "223",
    height: "24"
  }), React__default.createElement("rect", {
    x: "300",
    y: "315",
    rx: "4",
    ry: "4",
    width: "85",
    height: "24"
  })) : React__default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "8",
    ry: "8",
    width: "385",
    height: "340"
  }));
};

var SkeletonUserCard = function SkeletonUserCard(_a) {
  var className = _a.className;
  return React__default.createElement(SkeletonContentLoader, {
    className: className,
    height: 154,
    width: 90
  }, React__default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "4",
    ry: "4",
    width: "90",
    height: "90"
  }), React__default.createElement("rect", {
    x: "0",
    y: "98",
    rx: "4",
    ry: "4",
    width: "90",
    height: "24"
  }), React__default.createElement("rect", {
    x: "0",
    y: "130",
    rx: "4",
    ry: "4",
    width: "35",
    height: "24"
  }), React__default.createElement("rect", {
    x: "55",
    y: "130",
    rx: "4",
    ry: "4",
    width: "35",
    height: "24"
  }));
};

var Skeleton = function Skeleton(_a) {
  var className = _a.className,
      height = _a.height,
      width = _a.width;
  return React__default.createElement(SkeletonContentLoader, {
    className: className,
    height: height,
    width: width
  }, React__default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "1",
    ry: "1",
    width: width.toString(),
    height: height.toString()
  }));
};

var MIN_YEAR = 1900;

var YearSelect = function YearSelect(_a) {
  var value = _a.value,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      onSelect = _a.onSelect,
      onBlur = _a.onBlur,
      onDeselect = _a.onDeselect,
      min = _a.min,
      props = __rest(_a, ["value", "defaultValue", "onChange", "onSelect", "onBlur", "onDeselect", "min"]);

  var years = React.useMemo(function () {
    var now = new Date().getFullYear();
    var year = now;
    var list = [];

    while (year >= (min || MIN_YEAR)) {
      list.push(year);
      year -= 1;
    }

    return list;
  }, []);
  var handleChange = React.useCallback(function (year, option) {
    if (onChange) onChange(year ? new Date(year, 0, 3) : undefined, option);
  }, [onChange]);
  var handleSelect = React.useCallback(function (year, option) {
    if (onSelect) onSelect(year ? new Date(year, 0, 3) : undefined, option);
  }, [onSelect]);
  var handleBlur = React.useCallback(function (year) {
    if (onBlur) onBlur(year ? new Date(year, 0, 3) : undefined);
  }, [onBlur]);
  var handleDeselect = React.useCallback(function (year) {
    if (onDeselect) onDeselect(year ? new Date(year, 0, 3) : undefined);
  }, [onDeselect]);
  return React__default.createElement(Select, _assign({}, props, {
    defaultValue: defaultValue && defaultValue.getFullYear()
  }, value ? {
    value: value.getFullYear()
  } : {}, {
    onChange: handleChange,
    onSelect: handleSelect,
    onBlur: handleBlur,
    onDeselect: handleDeselect
  }), React__default.createElement(Option$4, {
    value: undefined
  }), years.map(function (year) {
    return React__default.createElement(Option$4, {
      value: year,
      key: year
    }, year);
  }));
};

var styles$K = {
  "container": "FilterButton-module_container__3h_xk",
  "icon": "FilterButton-module_icon__2C0_q",
  "title": "FilterButton-module_title__1CaXY",
  "active": "FilterButton-module_active__2OVhp",
  "overlay": "FilterButton-module_overlay__2QrEo"
};

var FilterButton = function FilterButton(_a) {
  var _b;

  var icon = _a.icon,
      title = _a.title,
      content = _a.content,
      id = _a.id,
      popoverVisible = _a.popoverVisible,
      onUpdatePopoverVisible = _a.onUpdatePopoverVisible,
      loading = _a.loading,
      height = _a.height,
      width = _a.width,
      closeFilter = _a.closeFilter;

  var _c = React.useState(null),
      anchorEl = _c[0],
      setAnchorEl = _c[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(e) {
    setAnchorEl(e.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  React.useEffect(function () {
    if (closeFilter) {
      handleClose();
    }
  }, [closeFilter]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("button", {
    className: classNames(styles$K.container, (_b = {}, _b[styles$K.active] = popoverVisible, _b)),
    onClick: function onClick(e) {
      return handleClick(e);
    }
  }, React__default.createElement("div", {
    className: styles$K.icon
  }, icon), React__default.createElement("div", {
    className: styles$K.title
  }, title)), React__default.createElement(material.Popover, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    anchorEl: anchorEl,
    onClose: handleClose,
    open: open,
    PaperProps: {
      style: {
        width: "" + width,
        height: height
      }
    }
  }, React__default.createElement(material.Typography, {
    sx: {
      p: 2
    }
  }, loading ? React__default.createElement(Loading, null) : content)));
};

var styles$L = {
  "container": "FilterCard-module_container__1PqLZ",
  "buttonContainer": "FilterCard-module_buttonContainer__1HtBm",
  "imgContainer": "FilterCard-module_imgContainer__3KG3d",
  "label": "FilterCard-module_label__2GW4w"
};

var FilterCard = function FilterCard(_a) {
  var label = _a.label,
      img = _a.img,
      onClick = _a.onClick;
  return React__default.createElement("div", {
    className: styles$L.container
  }, React__default.createElement(InvisibleButton, {
    onClick: onClick,
    className: styles$L.buttonContainer
  }, React__default.createElement("div", {
    className: styles$L.imgContainer
  }, React__default.createElement("img", {
    src: img
  })), React__default.createElement("span", {
    className: styles$L.label
  }, label)));
};

var styles$M = {
  "container": "FilterList-module_container__1Ad1r",
  "category": "FilterList-module_category__3n2fO",
  "list": "FilterList-module_list__62Sma",
  "object": "FilterList-module_object__1E-B_"
};

var FilterList = function FilterList(_a) {
  var list = _a.list,
      onClickObject = _a.onClickObject,
      language = _a.language;
  return React__default.createElement("div", {
    className: styles$M.container
  }, React__default.createElement("ul", {
    className: styles$M.list
  }, React__default.createElement("li", {
    key: list.id,
    style: {
      fontWeight: "bold"
    }
  }, React__default.createElement(InvisibleButton, {
    className: styles$M.object,
    onClick: function onClick() {
      return onClickObject(list.name, list.id, exports.FilterType.OBJECT_PARENT);
    }
  }, language && language == 'fr' ? list.slug.charAt(0).toUpperCase() + list.slug.slice(1) : list.name)), list.childs.map(function (child) {
    return React__default.createElement("li", {
      key: child.id
    }, React__default.createElement(InvisibleButton, {
      className: styles$M.object,
      onClick: function onClick() {
        return onClickObject(child.name, child.id, exports.FilterType.OBJECT);
      }
    }, language && language == 'fr' ? child.slug.charAt(0).toUpperCase() + child.slug.slice(1) : child.name));
  })));
};

var FilterTag = function FilterTag(_a) {
  var filter = _a.filter,
      _onClose2 = _a.onClose;
  return React__default.createElement(Tag, {
    type: exports.TagType.ACTIVE,
    size: exports.Size.LARGE,
    closable: true,
    onClose: function onClose() {
      return _onClose2(filter);
    }
  }, filter.label);
};

var styles$N = {
  "container": "FiltersContainer-module_container__3BsAC",
  "buttonsContainer": "FiltersContainer-module_buttonsContainer__2Aaao",
  "actions": "FiltersContainer-module_actions__3tdDu",
  "tagsContainer": "FiltersContainer-module_tagsContainer__3j-yy",
  "open": "FiltersContainer-module_open__11Ibj",
  "-webkit-mask": "FiltersContainer-module_mask__3Tbjt",
  "mask": "FiltersContainer-module_mask__3Tbjt",
  "visible": "FiltersContainer-module_visible__2IopO"
};

var FiltersContainer = function FiltersContainer(_a) {
  var _b, _c;

  var filterButtons = _a.filterButtons,
      filters = _a.filters,
      onCloseFilter = _a.onCloseFilter,
      onResetFilters = _a.onResetFilters,
      visibleButtonsIds = _a.visibleButtonsIds,
      onUpdatePopoverVisible = _a.onUpdatePopoverVisible,
      reinitLabel = _a.reinitLabel,
      className = _a.className,
      buttonsContainerClassName = _a.buttonsContainerClassName,
      tagsContainerClassName = _a.tagsContainerClassName,
      _d = _a.buttonTheme,
      buttonTheme = _d === void 0 ? exports.Theme.BLACK : _d,
      loading = _a.loading,
      closeFilter = _a.closeFilter; // TODO: Ugly hack for demo purposes. We don't want to show HAVE_THUMBNAIL, ENABLED and ONLY_VISIBLE filters

  var hasFilters = filters.filter(function (f) {
    return f.type !== exports.FilterType.HAVE_THUMBNAIL && f.type !== exports.FilterType.ENABLED && f.type !== exports.FilterType.ONLY_VISIBLE;
  }).length > 0;
  var isOpen = visibleButtonsIds.length > 0;
  return React__default.createElement("div", {
    className: classNames(styles$N.container, className)
  }, React__default.createElement("div", {
    className: classNames(styles$N.buttonsContainer, buttonsContainerClassName)
  }, filterButtons.map(function (filterButton) {
    return React__default.createElement(FilterButton, {
      id: filterButton.id,
      key: filterButton.id,
      icon: filterButton.icon,
      title: filterButton.label,
      content: filterButton.content,
      width: filterButton.width,
      height: filterButton.height,
      popoverVisible: visibleButtonsIds.some(function (id) {
        return id === filterButton.id;
      }),
      onUpdatePopoverVisible: onUpdatePopoverVisible,
      loading: loading,
      closeFilter: closeFilter
    });
  }), hasFilters && React__default.createElement("div", {
    className: styles$N.actions
  }, React__default.createElement(Button, {
    theme: buttonTheme,
    uppercase: true,
    onClick: onResetFilters,
    disabled: !hasFilters
  }, reinitLabel))), React__default.createElement("div", {
    className: classNames(styles$N.tagsContainer, tagsContainerClassName, (_b = {}, _b[styles$N.open] = hasFilters, _b))
  }, // TODO: Ugly hack for demo purposes. We don't want to show HAVE_THUMBNAIL, ENABLED and ONLY_VISIBLE filters
  filters.filter(function (f) {
    return f.type !== exports.FilterType.HAVE_THUMBNAIL && f.type !== exports.FilterType.ENABLED && f.type !== exports.FilterType.ONLY_VISIBLE;
  }).map(function (filter, index) {
    return React__default.createElement(FilterTag, {
      key: index,
      filter: filter,
      onClose: onCloseFilter
    });
  })), React__default.createElement("div", {
    className: classNames(styles$N.mask, (_c = {}, _c[styles$N.visible] = isOpen, _c))
  }), React__default.createElement(ScrollLock, {
    isActive: isOpen
  }));
};

var styles$O = {
  "container": "BrandFilter-module_container__ygVnC",
  "promotedBrandContainer": "BrandFilter-module_promotedBrandContainer__1QD8K",
  "brandContainer": "BrandFilter-module_brandContainer__3rKXP",
  "name": "BrandFilter-module_name__3MQgu",
  "list": "BrandFilter-module_list__2ZEE5"
};

var BrandFilter = function BrandFilter(_a) {
  var promotedBrands = _a.promotedBrands,
      brandLexique = _a.brandLexique,
      onValidate = _a.onValidate,
      loading = _a.loading;
  if (loading || !brandLexique) return null;
  return React__default.createElement("div", {
    className: styles$O.container
  }, promotedBrands && React__default.createElement("div", {
    className: styles$O.promotedBrandContainer
  }, promotedBrands.map(function (b) {
    return React__default.createElement("div", {
      key: b.id,
      onClick: function onClick() {
        return onValidate(b.name, b.id);
      }
    }, React__default.createElement(Card, {
      ratio: [1, 1],
      title: "",
      footer: "",
      side: "",
      image: b.logo && b.logo.url
    }));
  })), React__default.createElement("div", {
    className: styles$O.brandContainer
  }, Object.keys(brandLexique).sort().map(function (key, index) {
    var items = brandLexique[key];
    var list = {
      id: index.toString(),
      name: key.toUpperCase(),
      slug: key,
      enabled: true,
      childs: items.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          slug: item.slug,
          enabled: true
        };
      })
    };
    return React__default.createElement("div", {
      className: styles$O.list,
      key: key
    }, React__default.createElement(FilterList, {
      list: list,
      onClickObject: function onClickObject(label, value) {
        return onValidate(label, value);
      }
    }));
  })));
};

var styles$P = {
  "container": "ColorFilter-module_container__3e_31",
  "colorButton": "ColorFilter-module_colorButton__xxvcx"
};

var ColorFilter = function ColorFilter(_a) {
  var onValidate = _a.onValidate,
      colorTags = _a.colorTags,
      loading = _a.loading,
      language = _a.language;
  return React__default.createElement("div", null, loading ? React__default.createElement(Icon, {
    type: "loading"
  }) : React__default.createElement("div", {
    className: styles$P.container
  }, colorTags.map(function (color, index) {
    return React__default.createElement(ColorButton, {
      className: styles$P.colorButton,
      key: color.id,
      color: {
        id: color.id,
        name: language && language == 'fr' ? color.slug.charAt(0).toUpperCase() + color.slug.slice(1) : color.name,
        hexa: color.hexaColor || '',
        index: index
      },
      showName: true,
      onClick: function onClick() {
        return onValidate(color.name, color.id);
      }
    });
  })));
};

var styles$Q = {
  "container": "CategoriesList-module_container__2l3p8",
  "list": "CategoriesList-module_list__3t9Ee",
  "object": "CategoriesList-module_object__1xFiL",
  "materialImage": "CategoriesList-module_materialImage__-dA1x"
};

var CategoriesList = function CategoriesList(_a) {
  var images = _a.images,
      list = _a.list,
      onClickObject = _a.onClickObject,
      language = _a.language;

  var getImages = function getImages(materialSlug) {
    if (images) {
      if (materialSlug === "beton") return images.beton;
      if (materialSlug === "tissu") return images.tissu;
      if (materialSlug === "verre") return images.verre;
      if (materialSlug === "cuir") return images.cuir;
      if (materialSlug === "bois") return images.bois;
      if (materialSlug === "metal") return images.metal;
      if (materialSlug === "marbre") return images.marbre;
      if (materialSlug === "velours") return images.velours;
      if (materialSlug === "plastique") return images.plastique;
      if (materialSlug === "ceramic") return images.ceramic;
    }
  };

  return React__default.createElement("div", {
    className: styles$Q.container
  }, React__default.createElement("div", {
    className: styles$Q.list
  }, React__default.createElement(InvisibleButton, {
    className: styles$Q.object,
    onClick: function onClick() {
      return onClickObject(list.name, list.id);
    }
  }, React__default.createElement("img", {
    src: getImages(list.slug),
    alt: "",
    className: styles$Q.materialImage
  }), " \xA0", language && language == 'fr' ? list.slug.charAt(0).toUpperCase() + list.slug.slice(1) : list.name)));
};

var styles$R = {
  "container": "MaterialsFilter-module_container__3CXSO"
};

var MaterialsFilter = function MaterialsFilter(_a) {
  var onValidate = _a.onValidate,
      images = _a.images,
      productMaterialTags = _a.productMaterialTags,
      loading = _a.loading,
      language = _a.language;
  return React__default.createElement("div", null, loading ? React__default.createElement(Icon, {
    type: "loading"
  }) : React__default.createElement("div", {
    className: styles$R.list
  }, productMaterialTags.map(function (tag) {
    return React__default.createElement(CategoriesList, {
      list: tag,
      images: images,
      key: tag.id,
      onClickObject: function onClickObject(label, value) {
        return onValidate(label, value);
      },
      language: language
    });
  })));
};

var styles$S = {
  "container": "ObjectFilter-module_container__1_2yK",
  "list": "ObjectFilter-module_list__nbpG0"
};

var ObjectFilter = function ObjectFilter(_a) {
  var onValidate = _a.onValidate,
      objectProductCategories = _a.objectProductCategories,
      language = _a.language;
  return React__default.createElement("div", null, React__default.createElement("div", {
    className: styles$S.container
  }, objectProductCategories.map(function (tag) {
    return React__default.createElement("div", {
      className: styles$S.list,
      key: tag.id
    }, React__default.createElement(FilterList, {
      language: language,
      list: tag,
      onClickObject: function onClickObject(label, value, type) {
        return onValidate(label, value, type);
      }
    }));
  })));
};

var styles$T = {
  "container": "OriginFilter-module_container__1OU7X",
  "countryContainer": "OriginFilter-module_countryContainer__2jkUo",
  "flagContainer": "OriginFilter-module_flagContainer__fSXKT",
  "countryLabel": "OriginFilter-module_countryLabel__2WcC6"
};

var _a$1;

var COUNTRY_CODE_TO_INTL_ID = (_a$1 = {}, _a$1['AT'] = 'country.austria', _a$1['BE'] = 'country.belgium', _a$1['CH'] = 'country.switzerland', _a$1['CZ'] = 'country.czech', _a$1['DE'] = 'country.deutschland', _a$1['DK'] = 'country.denmark', _a$1['ES'] = 'country.spain', _a$1['FI'] = 'country.finland', _a$1['FR'] = 'country.france', _a$1['GB'] = 'country.uk', _a$1['HU'] = 'country.hungary', _a$1['IT'] = 'country.italy', _a$1['JP'] = 'country.japan', _a$1['NL'] = 'country.netherlands', _a$1['NO'] = 'country.norway', _a$1['PL'] = 'country.poland', _a$1['PT'] = 'country.portugal', _a$1['SE'] = 'country.sweden', _a$1['AE'] = 'country.unitedArabEmirates', _a$1['UA'] = 'country.ukraine', _a$1['US'] = 'country.usa', _a$1);
var countriesNotTranslated = [{
  label: 'country.austria',
  code: 'AT'
}, {
  label: 'country.belgium',
  code: 'BE'
}, {
  label: 'country.czech',
  code: 'CZ'
}, {
  label: 'country.denmark',
  code: 'DK'
}, {
  label: 'country.deutschland',
  code: 'DE'
}, {
  label: 'country.finland',
  code: 'FI'
}, {
  label: 'country.france',
  code: 'FR'
}, {
  label: 'country.hungary',
  code: 'HU'
}, {
  label: 'country.italy',
  code: 'IT'
}, {
  label: 'country.japan',
  code: 'JP'
}, {
  label: 'country.netherlands',
  code: 'NL'
}, {
  label: 'country.norway',
  code: 'NO'
}, {
  label: 'country.poland',
  code: 'PL'
}, {
  label: 'country.portugal',
  code: 'PT'
}, {
  label: 'country.spain',
  code: 'ES'
}, {
  label: 'country.sweden',
  code: 'SE'
}, {
  label: 'country.switzerland',
  code: 'CH'
}, {
  label: 'country.uk',
  code: 'GB'
}, {
  label: 'country.unitedArabEmirates',
  code: 'AE'
}, {
  label: 'country.ukraine',
  code: 'UA'
}, {
  label: 'country.usa',
  code: 'US'
}];

var translateCountries = function translateCountries(formatMessage) {
  return countriesNotTranslated.map(function (c) {
    return _assign({}, c, {
      label: formatMessage({
        id: c.label
      })
    });
  });
}; // TODO: change with Addsome flags svgs


var OriginFilter = function OriginFilter(_a) {
  var onValidate = _a.onValidate,
      countries = _a.countries;
  return React__default.createElement("div", {
    className: styles$T.container
  }, countries.map(function (country) {
    return React__default.createElement("div", {
      className: styles$T.countryContainer,
      key: country.code,
      onClick: function onClick() {
        return onValidate(country.label, country.code);
      }
    }, React__default.createElement("div", {
      className: styles$T.flagContainer
    }, React__default.createElement(Flag, {
      code: country.code,
      height: 16,
      width: 24
    })), React__default.createElement("span", {
      className: styles$T.countryLabel
    }, country.label));
  }));
};

var styles$U = {
  "slider": "PriceFilter-module_slider__1PCLt",
  "range": "PriceFilter-module_range__1yEm2",
  "buttons": "PriceFilter-module_buttons__18ZfS"
};

var PriceFilter = function PriceFilter(_a) {
  var min = _a.min,
      max = _a.max,
      onValidate = _a.onValidate,
      applyLabel = _a.applyLabel,
      clearLabel = _a.clearLabel;

  var _b = React.useState([min, max]),
      priceRange = _b[0],
      setPriceRange = _b[1];

  var isNumberInRange = function isNumberInRange(value) {
    var num = parseInt(value, 10);
    return !isNaN(num) && num >= 0 && num <= max;
  };

  return React__default.createElement("div", {
    style: {
      display: "flow"
    }
  }, React__default.createElement(Slider, {
    className: styles$U.slider,
    range: true,
    max: max,
    min: min,
    value: priceRange,
    tooltipVisible: false,
    onChange: function onChange(v) {
      return setPriceRange(v);
    }
  }), React__default.createElement("div", {
    className: styles$U.range
  }, React__default.createElement("input", {
    type: "number",
    value: priceRange[0],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setPriceRange([numValue, priceRange[1]]);
      }
    }
  }), React__default.createElement("span", null, " - "), React__default.createElement("input", {
    type: "number",
    value: priceRange[1],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setPriceRange([priceRange[0], numValue]);
      }
    }
  })), React__default.createElement("div", {
    className: styles$U.buttons
  }, React__default.createElement(Button, {
    size: exports.Size.MEDIUM,
    theme: exports.Theme.GHOST,
    onClick: function onClick() {
      return setPriceRange([min, max]);
    },
    uppercase: true
  }, clearLabel), React__default.createElement(Button, {
    theme: exports.Theme.BLACK,
    onClick: function onClick() {
      return onValidate(priceRange[0] + "-" + priceRange[1] + "\u20AC", priceRange);
    },
    className: styles$U.button,
    uppercase: true
  }, applyLabel)));
};

var styles$V = {
  "container": "RoomFilter-module_container__1q0Jr"
};

var RoomFilter = function RoomFilter(_a) {
  var onValidate = _a.onValidate,
      roomTags = _a.roomTags,
      loading = _a.loading,
      language = _a.language;

  var _b = useHorizontalScroll(),
      scrollContainerRef = _b.scrollContainerRef,
      handleWheel = _b.handleWheel;

  return React__default.createElement("div", null, loading ? React__default.createElement(Icon, {
    type: "loading"
  }) : React__default.createElement("div", {
    className: styles$V.container,
    ref: scrollContainerRef,
    onWheel: function onWheel() {
      return handleWheel;
    }
  }, roomTags.map(function (tag) {
    return React__default.createElement(FilterCard, {
      label: language && language == 'fr' ? tag.slug.charAt(0).toUpperCase() + tag.slug.slice(1) : tag.name,
      img: tag.picture && tag.picture.url || '',
      onClick: function onClick() {
        return onValidate(tag.name, tag.id);
      },
      key: tag.id
    });
  })));
};

var styles$W = {
  "container": "StyleFilter-module_container__1Z9-J"
};

var StyleFilter = function StyleFilter(_a) {
  var onValidate = _a.onValidate,
      styleTags = _a.styleTags,
      loading = _a.loading,
      language = _a.language;

  var _b = useHorizontalScroll(),
      scrollContainerRef = _b.scrollContainerRef,
      handleWheel = _b.handleWheel;

  return React__default.createElement("div", null, loading ? React__default.createElement(Icon, {
    type: "loading"
  }) : React__default.createElement("div", {
    className: styles$W.container,
    ref: scrollContainerRef,
    onWheel: function onWheel() {
      return handleWheel;
    }
  }, styleTags.map(function (tag) {
    return React__default.createElement(FilterCard, {
      label: language && language == 'fr' ? tag.slug.charAt(0).toUpperCase() + tag.slug.slice(1) : tag.name,
      img: tag.picture && tag.picture.url || '',
      onClick: function onClick() {
        return onValidate(tag.name, tag.id);
      },
      key: tag.id
    });
  })));
};

var style = {
  "have3DFilterContainer": "Have3dFilter-module_have3DFilterContainer__ubBIA"
};

var Have3dFilter = function Have3dFilter(_a) {
  var messages = _a.messages,
      have3d = _a.have3d,
      onValidate = _a.onValidate;
  return React__default.createElement("div", {
    className: style.have3DFilterContainer
  }, React__default.createElement(Radio.Group, {
    value: have3d,
    onChange: function onChange(e) {
      var have3d = e.target.value;
      onValidate(have3d ? messages.with3d : messages.without3d, have3d);
    }
  }, React__default.createElement(Radio.Button, {
    name: "with3d",
    value: true
  }, React__default.createElement(Icon, {
    type: "check-circle"
  }), React__default.createElement("span", null, messages.with3d)), React__default.createElement(Radio.Button, {
    name: "without3d",
    value: false
  }, React__default.createElement(Icon, {
    type: "close-circle"
  }), React__default.createElement("span", null, messages.without3d))));
};

var styles$X = {
  "slider": "DimensionsFilter-module_slider__2Uiux",
  "range": "DimensionsFilter-module_range__2Giz0",
  "buttons": "DimensionsFilter-module_buttons__jAzC0"
};

var DimensionsFilter = function DimensionsFilter(_a) {
  var min = _a.min,
      max = _a.max,
      onValidate = _a.onValidate,
      applyLabel = _a.applyLabel,
      clearLabel = _a.clearLabel,
      widthLabel = _a.widthLabel,
      heightLabel = _a.heightLabel,
      depthLabel = _a.depthLabel;

  var _b = React.useState(1),
      widthMin = _b[0],
      setWidthMin = _b[1];

  var _c = React.useState(500),
      widthMax = _c[0],
      setWidthMax = _c[1];

  var _d = React.useState(1),
      heightMin = _d[0],
      setHeightMin = _d[1];

  var _e = React.useState(500),
      heightMax = _e[0],
      setHeightMax = _e[1];

  var _f = React.useState(1),
      depthMin = _f[0],
      setDepthMin = _f[1];

  var _g = React.useState(500),
      depthMax = _g[0],
      setDepthMax = _g[1];

  var _h = React.useState([1, 500]),
      widthRange = _h[0],
      setWidthRange = _h[1];

  var _j = React.useState([1, 500]),
      heightRange = _j[0],
      setHeightRange = _j[1];

  var _k = React.useState([1, 500]),
      depthRange = _k[0],
      setDepthRange = _k[1];

  var changeValues = function changeValues(propertyType, valuesArray) {
    if (propertyType === 'width') {
      setWidthMin(valuesArray[0]);
      setWidthMax(valuesArray[1]);
    } else if (propertyType === 'height') {
      setHeightMin(valuesArray[0]);
      setHeightMax(valuesArray[1]);
    } else if (propertyType === 'depth') {
      setDepthMin(valuesArray[0]);
      setDepthMax(valuesArray[1]);
    }
  };

  var isNumberInRange = function isNumberInRange(value) {
    var num = parseInt(value, 10);
    return !isNaN(num) && num >= 1 && num <= 500;
  };

  return React__default.createElement("div", null, widthLabel, ":", React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React__default.createElement(Slider, {
    className: styles$X.slider,
    range: true,
    max: 500,
    min: 1,
    value: widthRange,
    tooltipVisible: false,
    onChange: function onChange(v) {
      setWidthRange(v);
      changeValues('width', v);
    }
  }), React__default.createElement("div", {
    className: styles$X.range
  }, React__default.createElement("input", {
    type: "number",
    value: widthRange[0],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setWidthRange([numValue, widthRange[1]]);
        setWidthMin(numValue);
      }
    }
  }), React__default.createElement("span", null, " - "), React__default.createElement("input", {
    type: "number",
    value: widthRange[1],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setWidthRange([widthRange[0], numValue]);
        setWidthMax(numValue);
      }
    }
  }))), React__default.createElement("br", null), heightLabel, ":", React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React__default.createElement(Slider, {
    className: styles$X.slider,
    range: true,
    max: 500,
    min: 1,
    value: heightRange,
    tooltipVisible: false,
    onChange: function onChange(v) {
      setHeightRange(v);
      changeValues('height', v);
    }
  }), React__default.createElement("div", {
    className: styles$X.range
  }, React__default.createElement("input", {
    type: "number",
    value: heightRange[0],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setHeightRange([numValue, heightRange[1]]);
        setHeightMin(numValue);
      }
    }
  }), React__default.createElement("span", null, " - "), React__default.createElement("input", {
    type: "number",
    value: heightRange[1],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setHeightRange([heightRange[0], numValue]);
        setHeightMax(numValue);
      }
    }
  }))), React__default.createElement("br", null), depthLabel, ":", React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React__default.createElement(Slider, {
    className: styles$X.slider,
    range: true,
    max: 500,
    min: 1,
    value: depthRange,
    tooltipVisible: false,
    onChange: function onChange(v) {
      setDepthRange(v);
      changeValues('depth', v);
    }
  }), React__default.createElement("div", {
    className: styles$X.range
  }, React__default.createElement("input", {
    type: "number",
    value: depthRange[0],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setDepthRange([numValue, depthRange[1]]);
        setDepthMin(numValue);
      }
    }
  }), React__default.createElement("span", null, " - "), React__default.createElement("input", {
    type: "number",
    value: depthRange[1],
    onChange: function onChange(e) {
      var newValue = e.target.value.replace(/\D/g, '');

      if (isNumberInRange(newValue)) {
        var numValue = parseInt(newValue, 10);
        setDepthRange([depthRange[0], numValue]);
        setDepthMax(numValue);
      }
    }
  }))), React__default.createElement("br", null), React__default.createElement("div", {
    className: styles$X.buttons
  }, React__default.createElement(Button, {
    theme: exports.Theme.BLACK,
    onClick: function onClick() {
      onValidate(widthLabel + ": " + widthMin + "-" + widthMax + "cm | " + heightLabel + ": " + heightMin + "-" + heightMax + "cm | " + depthLabel + ": " + depthMin + "-" + depthMax + "cm ", [widthMin, widthMax, heightMin, heightMax, depthMin, depthMax]);
    },
    className: styles$X.button,
    uppercase: true
  }, applyLabel)));
};

exports.AutoComplete = AutoComplete;
exports.AutoCompleteField = AutoCompleteField;
exports.BarChart = BarChart;
exports.BrandFilter = BrandFilter;
exports.Breadcrumb = Breadcrumb;
exports.Button = Button;
exports.COUNTRY_CODE_TO_INTL_ID = COUNTRY_CODE_TO_INTL_ID;
exports.Card = Card;
exports.CardGrid = CardGrid;
exports.Carousel = CustomCarousel;
exports.Cell = Cell;
exports.ColorButton = ColorButton;
exports.ColorFilter = ColorFilter;
exports.ConnectionView = ConnectionView;
exports.Container = Container;
exports.ContentContainer = ContentContainer;
exports.DatePicker = DatePicker;
exports.DateRangePicker = DateRangePicker;
exports.Diagram = Diagram;
exports.DimensionsFilter = DimensionsFilter;
exports.FilterButton = FilterButton;
exports.FilterCard = FilterCard;
exports.FilterList = FilterList;
exports.FilterTag = FilterTag;
exports.FiltersContainer = FiltersContainer;
exports.FormulaCard = FormulaCard;
exports.Have3dFilter = Have3dFilter;
exports.Header = Header;
exports.Heading = Heading;
exports.InfiniteGridWithSearch = InfiniteGridWithSearch;
exports.InputField = InputField;
exports.InputNumber = InputNumber;
exports.InputURL = InputURL;
exports.InvisibleButton = InvisibleButton;
exports.ItemPicker = ItemPicker;
exports.Layout = Layout;
exports.Loading = Loading;
exports.LoginLayout = LoginLayout;
exports.MaterialsFilter = MaterialsFilter;
exports.Modal = Modal;
exports.MultipleSelect = MultipleSelect;
exports.ObjectFilter = ObjectFilter;
exports.Option = Option$4;
exports.OriginFilter = OriginFilter;
exports.PopOverMenu = PopOverMenu;
exports.PopOverMenuItem = PopOverMenuItem;
exports.Popconfirm = Popconfirm;
exports.PriceFilter = PriceFilter;
exports.QuoteLine = QuoteLine;
exports.RoomFilter = RoomFilter;
exports.Row = Row;
exports.RowHeader = RowHeader;
exports.Searchbar = Searchbar;
exports.Select = Select;
exports.SelectedNumber = SelectedNumber;
exports.Skeleton = Skeleton;
exports.SkeletonCard = SkeletonCard;
exports.SkeletonContentLoader = SkeletonContentLoader;
exports.SkeletonThumbnail = SkeletonThumbnail;
exports.SkeletonUserCard = SkeletonUserCard;
exports.Steps = Steps;
exports.StyleFilter = StyleFilter;
exports.Switch = Switch;
exports.Table = Table;
exports.Tabs = Tabs;
exports.Tag = Tag;
exports.TagsList = TagsList;
exports.TextArea = TextArea;
exports.Thumbnail = Thumbnail;
exports.UserMenu = UserMenu;
exports.YearSelect = YearSelect;
exports.translateCountries = translateCountries;